import React, { useEffect, useState } from 'react'
import { postDataPDFLiquidarUnProcedimineto, postInformacionEmpresa, postLiquidacionProcedimientosQx, postListComplicacionesDescripcionQx,  postPreciosPaqueteLiquidacionQx,  postPreciosProcedimientosLiquidacionQx } from '../../../services/PaginaRuta'
import ModalValidacionSelectLiquidacionQx from './ModalValidacionSelectLiquidacionQx';
import {PDFDownloadLink} from '@react-pdf/renderer'
import ModalMedicoLiquidacionQx from './ModalMedicoLiquidacionQx';
import ModalConfirmarLiquidacionQX from './ModalConfirmarLiquidacionQX';
import LoadingModal from '../../LoadingModal';
import ModalValidarPTCODILiquidacion from './ModalValidarPTCODILiquidacion';
import ModalValidarParticipo from './ModalValidarParticipo';
import ModalPDFPaquetesYFormasLiquidar from './ModalPDFPaquetesYFormasLiquidar';
import ModalConfirmarLiquidacionPaqueteYFormasLiquidar from './ModalConfirmarLiquidacionPaqueteYFormasLiquidar';
import ModalValidarTarifarioLiquidacionQX from './ModalValidarTarifarioLiquidacionQX';


const ModalLiquidarPaquetesYFormasLiquidacion = ({setmodalOnLiquidacion,item,setactualizarDataLiquidacion, dataOpcionCirugia}) => {   
  const [modalOnTarifario, setmodalOnTarifario]=useState(false)
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));  
  const [variablePTCODI, setvariablePTCODI]=useState('')
    const [agrupadorMULTBILAINDV, setagrupadorMULTBILAINDV]=useState('')
    const [modalOnValidarPTCodi, setmodalOnValidarPTCodi]=useState(false)
    const [modalOnValidarParticipo, setmodalOnValidarParticipo]=useState(false)
    const [valorTotalProcedimientos, setValorTotalProcedimientos] = useState(0)
    const [dataProcedimientosPaquete, setDataProcedimientosPaquete] = useState([])
    const [informacionEmpresa,setinformacionEmpresa]=useState({
      EMPCOD: "",
      EmpNit: "",
      EmpRazSoc: "",
      MCDnom: "",
      MCDpto: "",
      T2_EMPCOD: "",
  
    })  
    const [dataAnestesiologo, setdataAnestesiologo]=useState({
      nombreMedicoEs:'',
      codigoMedicoEs:''
    })
    const [complicacionesDx, setcomplicacionesDx]=useState({
      DxCompl:'',
      DMNomb:''
    })
    const [nombreIdContrato, setnombreIdContrato]=useState('')
    const [totalPrecioProcedimiento, settotalPrecioProcedimiento]=useState(0)
    const [selectedRowHonorario, setSelectedRowHonorario] = useState(null);
    const [modalOnMedico, setmodalOnMedico]=useState(false)
    const [loadingProcedimientosPrecios, setloadingProcedimientosPrecios]=useState(true)    
    const [dataPreciosTabla, setdataPreciosTabla]=useState([])
    const [dataUser,setdataUser] =useState([])
    const [dataPreciosPDF, setdataPreciosPDF]=useState([{
      CRGPRCAUT:"",
      CantidadUVR:"",
      CrgCod:"",
      PrNomb:"                                                                                                                                                                                                      ",
      ProCirCod:"",
      ProEmpCod:"",
      ProMCDpto:"",
      especilidadCirujano:"",
      opcion:"",
      orden:undefined,
      precioProcedimiento:0,
      precios:[{
        CantidadUVR:"",
        CirujanoSoN:"",
        CodigoEspecialidad:"",
        CodigoFactor:"",
        CodigoFormaLiquidacion:"",
        CodigoHonorario:"",
        CodigoMedico:"",
        CodigoProcedimiento:"",
        DescFormaLiquidacion:"U",
        DescripcionFormaLiquidacion:"",
        DescripcionHonorario:"",
        IndicadorCDeNoIncremento:"",
        NombreEspecialidad:"",
        NombreMedico:"",
        NombreProcedimiento:"",
        NumeroOrden:"",
        PorcOrden:0,
        PorcTarifaBase:"",
        RequiereCodigoProfesional:"",
        ValorHonorario:0,
        ValorHonorarioImprLiqCir:0,
        ValordeHonorarios:"",
        tipoHojaFact:""
      }],
      tipoHojaFact:"",
      via:""
    }])    
    const [modalOnValidarSelect, setmodalOnValidarSelect]=useState(false)
    const [modalOnConfirmarLiquidacion, setmodalOnConfirmarLiquidacion]=useState(false)
    const [mensajeSelect, setmensajeSelect]=useState('')    
    const [loading,setloading]=useState(false)
    const [dataProcedimientos, setdataProcedimientos]=useState([{
      CRGPRCAUT:"",
      CantidadUVR:"",
      CrgCod:"",
      PrNomb:"",
      ProCirCod:"",
      ProEmpCod:"",
      ProMCDpto:"",
      especilidadCirujano:"",
      opcion:"",
      orden:undefined,
      precioProcedimiento:0,
      precios:[{ValorHonorario:0},{ValorHonorario:0}],
      tipoHojaFact:"",
      via:""
    }])    
    const [validarButtonDescargaPDF, setvalidarButtonDescargaPDF]=useState(true)
    const [dataPrecios, setdataPrecios]=useState([])    
    const [dataPDF, setdataPDF]=useState({
      CrgCnt0:"",
      CrgCod:"",
      CrgEst:"",
      EmpDsc:"",
      ForLiqCod:"",
      ForLiqDsc:"",
      ForLiqVlHn:"",
      ForLiqcar:"",
      HomProDsc:"",
      MECTope:"",
      MENNIT:"",
      MENOMB:"",
      MaeVlrFact:"",
      MaeVlrNoC:"",
      MaeVlrReg:"",
      MeCnsCnt:"",
      PTCntUvr:"",
      PTCodi:"",
      PTDesc: "",
      ProCirCod:"",
      ProCons:"",
      ProEmpCod:"",
      ProFec:"",
      ProFecF:"",
      ProHorF:"",
      ProHorI:"",
      ProMCDpto:"",
      ProSedQr:"",
      ProSit:"",
      TFCscP:"",
      TFcCodCam:"",
      TFcCodPab:"",
      TipHer:"",
      TrfCod:"",
      ViaCod:"",
      ViaIng:""
    })
    //cerrar el modal de los procedimientos qx a liquidar
    const handleCancelClick=()=>{
      setmodalOnLiquidacion(false)
    }

    
    //En esta funcion cargamos todos los endpoint de los precios y los procedimientos del usuario
    useEffect(()=>{
      console.log(item,'itemmmm')
      setloading(false)
      setdataUser(item)     
      
      const datosPacientePDF={
        TFCedu: item.MPCedu,
        TFTDoc: item.MPTDoc,
        TmCtvIng: item.ProCtvIn,
        ProEmpCod: item.ProEmpCod,
        MENNIT: item.ProEPS,
        ProMCDpto: item.ProMCDpto,
        ProCirCod: item.ProCirCod,
        CrgEst: 'S',
        MeCfcha1: item.ProFec,
        CodMed: item.ProPerSe1,
        ForLiqCod: '01',
        HnrCod: '01',
        //CodigoFormaLiquidacion: '01',
        NumContrato: item.ProEPS
      }
      console.log(datosPacientePDF,'ANTES')
      postDataPDFLiquidarUnProcedimineto(datosPacientePDF).then((res)=>{
        console.log(res.data,'data para pdf')
        

        setnombreIdContrato(`${item.ProEPS} - ${res.data[0].MENOMB}`)
        let PTCODI = res.data[0].PTCodi
        setvariablePTCODI(PTCODI)
        setdataPDF(res.data[0])
        /////////////////////////////////
        const procedimientos={
          ProEmpCod:usuarioInfo.Empresa,
          ProMCDpto:usuarioInfo.Sede,
          ProCirCod:item.ProCirCod,
          PTCodi: PTCODI
        }
        console.log(procedimientos,'ANTES PROCEDIMIENTO')
        postLiquidacionProcedimientosQx(procedimientos).then((res)=>{
          console.log(res.data,'procedimientos')
          //procedimientos que tienen formas de liquidacion
          const procedimientoFormasLiquidacion = item.Procedimientos.filter((item) => item.PTIndPaq === 'N' );

          //
          //const 

          //modificamos el array para agregar 
          let dataProcedi = getProcedimientosQueCoinciden(res.data, procedimientoFormasLiquidacion)
          //validar si es multiple o individual para el select
          let agrupadorProcedimiento = ''
          if(dataProcedi.length > 1){
            setagrupadorMULTBILAINDV('MULT')
            agrupadorProcedimiento = 'MULT'
            
          }else{
            setagrupadorMULTBILAINDV('INDV')
            agrupadorProcedimiento = 'INDV'
          }
          
          let nuevoDatosProcedimientos = dataProcedi.map((item)=>{return{...item,tipoHojaFact: 'seleccionar', via: 'seleccionar', especilidadCirujano:'1',opcion: item.ProSit,orden:undefined, agrupadorProcedimiento:agrupadorProcedimiento }})
          console.log(nuevoDatosProcedimientos,'nuevooo')
          //mostrar la data de los procedimientos
          setdataProcedimientos(nuevoDatosProcedimientos)
          let dataParaConsultarPrecios = dataProcedi.map((procedimiento)=>{
            return{
              codigoFormaLiquidacion:procedimiento.ForLiqCod, 
              codPortafolioProc:PTCODI, 
              codProcedimiento:procedimiento.CrgCod, 
              numContrato:item.ProEPS, 
              ViaProgQX:'1',//procedimiento.ViaIng, 
              EspCirProgQX:'1', 
              OpcionProgQX:procedimiento.ProSit, 
              NumeroOrden:'1',
              TipoTransaccion:'F',
              CodEmpresa:usuarioInfo.Empresa,
              CodSede:usuarioInfo.Sede,
              CodigoCirugia:item.ProCirCod,
              TipoProcQX : agrupadorProcedimiento
            }})
            console.log(dataParaConsultarPrecios,'IMPORTANTE')
         
          //array precios de todos los procedimientos 
          const arrayRecibido = {
            "arrayProcedimientos": dataParaConsultarPrecios
          };
          console.log(arrayRecibido,'IMPORTANTETETETTE')
          postPreciosProcedimientosLiquidacionQx(arrayRecibido).then((tabla)=>{
            //console.log(tabla.data,'precios Tabla88888888888888888888888')
            
            let agregarFacturableTabla = tabla.data.flat().map(item => {            
                return {...item, tipoHojaFact: 'seleccionar'};              
            });

            const buscarCantidadUVRss=(idProcedimiento)=>{
              const UVRcantidad = agregarFacturableTabla.find((item) => parseInt(item.CodigoProcedimiento) === parseInt(idProcedimiento));
              //console.log(UVRcantidad,'VAMOS')
              if(UVRcantidad){
                return  UVRcantidad.CantidadUVR
              }      
            }

            let agregarUVR = nuevoDatosProcedimientos.map((uvr)=>{return{...uvr, CantidadUVR: buscarCantidadUVRss(uvr.CrgCod)}})

            agregarUVR.sort((a, b) => b.CantidadUVR - a.CantidadUVR);

            setdataProcedimientos(agregarUVR)

            agregarUVR = agregarUVR.map((obj, index) => {
              return { ...obj, orden: index + 1 };
            });

            

            let dataAcomodarPrecios = agregarUVR.map((procedimiento)=>{
              return {
                codigoFormaLiquidacion:procedimiento.ForLiqCod, 
                codPortafolioProc:PTCODI, 
                codProcedimiento:procedimiento.CrgCod, 
                numContrato:item.ProEPS, 
                ViaProgQX:'1', 
                EspCirProgQX:'1', 
                OpcionProgQX: procedimiento.opcion, 
                NumeroOrden:`${procedimiento.orden}`,
                TipoTransaccion:'F',
                CodEmpresa:usuarioInfo.Empresa,
                CodSede:usuarioInfo.Sede,
                CodigoCirugia:item.ProCirCod,
                TipoProcQX : agrupadorProcedimiento
              }
            })

            //console.log(dataAcomodarPrecios,'HAYYYYYYYYYYYYYY')

            agregarFacturableTabla.sort((a, b) => b.CantidadUVR - a.CantidadUVR);
            console.log(agregarFacturableTabla,'WWWWWWWWWWWWW')
            setdataPreciosTabla(agregarFacturableTabla)
            //setdataPrecios(agregarFacturableTabla.flat())
            const arrayRecibidoPDF = {
              "arrayProcedimientos": dataAcomodarPrecios
            };
            postPreciosProcedimientosLiquidacionQx(arrayRecibidoPDF).then((pdf)=>{
              //console.log(pdf.data,'precios PDF')
              let agregarTipo = pdf.data.flat().map((item)=>{return{...item,tipoHojaFact: 'seleccionar'}})
              //console.log(agregarTipo,'agregarTipo')
              setdataPrecios(agregarTipo)
              
                let filtrarIDCirugias = (idCirugia) => {
                  //console.log(parseInt(idCirugia),'ACOMODARrrrr')
                  const filtrar = agregarTipo.filter((item)=> parseInt(idCirugia) === parseInt(item.CodigoProcedimiento))
                  if(filtrar){
                    //console.log(filtrar,'ACOMODAR')
                    return filtrar
                  }
                }
  
                const buscarCantidadUVRs=(idProcedimiento)=>{
                  const UVRcantidad = agregarTipo.find((item) => parseInt(item.CodigoProcedimiento) === parseInt(idProcedimiento));
                  //console.log(UVRcantidad,'VAMOS')
                  if(UVRcantidad){
                    return  UVRcantidad.CantidadUVR
                  }      
                }
  
                const calcularPrecioProcedimiento = (idCirugia) =>{
                  let preciosTotalProcedimiento = agregarTipo.reduce((acumulador, precios)=>{
                    if(parseInt(idCirugia) === parseInt(precios.CodigoProcedimiento)){
                      return acumulador + parseInt(precios.ValorHonorarioImprLiqCir)
                    }else{
                      return acumulador
                    }                    
                  },0)
                  return preciosTotalProcedimiento
                }
  
                
  
                let preciosPDF = nuevoDatosProcedimientos.map((item)=>{return{...item, precios:filtrarIDCirugias(item.CrgCod),CantidadUVR:buscarCantidadUVRs(item.CrgCod),precioProcedimiento: calcularPrecioProcedimiento(item.CrgCod),isFacturable:false}})
                console.log(preciosPDF,'VERRRRRRRRRRRRRRRR')
                //colocar en la variable orden el numeroOrden
                const arrayModificado = preciosPDF.map(item => {
                  // suponiendo que solo hay un objeto en la matriz de precios
                  if(item.precios[0]){
                    const { NumeroOrden } = item.precios[0];
                    return {...item, orden: NumeroOrden};
                  }else{
                    console.log('no hay precios')
                    setmodalOnTarifario(true)
                  }
                });
                //organizar de mayor a menor el 'orden'
                arrayModificado.sort((a, b) => b.orden - a.orden);
                setdataPreciosPDF(arrayModificado)
                console.log(arrayModificado,'preciosPDF AQUII')
  
                //setdataPreciosPDF(nuevoDatosProcedimientos)
                
            

            setTimeout(() => {          
              setloading(true)
            }, 3000);
            
           
  
              
            }).catch(error => {
              console.error("Hubo un error:", error);
                setmodalOnValidarPTCodi(true)
                setloading(true)
              // maneja el error adecuadamente, por ejemplo mostrando un mensaje al usuario
            });
          }).catch(error => {
            console.error("Hubo un error:", error);
              setmodalOnValidarPTCodi(true)
              setloading(true)
            // maneja el error adecuadamente, por ejemplo mostrando un mensaje al usuario
          });
        }).catch(error => {
          console.error("Hubo un error:", error);
            setmodalOnValidarPTCodi(true)
            setloading(true)
          // maneja el error adecuadamente, por ejemplo mostrando un mensaje al usuario
        });
       
      }).catch(error => {
        console.error("Hubo un error:", error);
          setmodalOnValidarPTCodi(true)
          setloading(true)
        // maneja el error adecuadamente, por ejemplo mostrando un mensaje al usuario
      });

      const dxPrincipa={
        CodEmpCod: usuarioInfo.Empresa,
        CodMcdpto:usuarioInfo.Sede,
        CodCir: item.ProCirCod
      }
      // postDxPrincipalDxComplicacionLiquidacionQx(dxPrincipa).then((res)=>{
      //   console.log(res.data,'COMPLICACIONES')
      //   if(res.data[0]){
      //     setcomplicacionesDx({
      //       DMCodi:res.data[0].DMCodi,
      //       DMNomb:res.data[0].DMNomb
      //     })
      //   }
        
      // })

      postListComplicacionesDescripcionQx(dxPrincipa).then((res)=>{
        if(res.data[0]){
          console.log(res.data,'COMPLICACIONES')
          setcomplicacionesDx({
            DxCompl:res.data[0].DxCompl,
            DMNomb:res.data[0].DMNomb
          })
        }
      })
      
      const datosEmpresa={
     "EMPCOD":usuarioInfo.Empresa,
     "MCDpto":usuarioInfo.Sede}
        console.log(datosEmpresa,'datos empresaa')
     postInformacionEmpresa(datosEmpresa).then((res)=>{
      console.log(res.data,'datos empresaa')
      if(res.data[0]){
        setinformacionEmpresa(res.data[0])
        console.log(res.data,'datos empresaa')
      }
      
    })


    },[])

    //array de paquetes
     useEffect(() => {
        //realizamos un filtro a los procedimientos de tipo paquete
          const procedimientoTipoPaquete = item.Procedimientos.filter((item) => item.PTIndPaq === 'S' );
          const precios={
            'arrayProcedimientos' : procedimientoTipoPaquete,
            'PTCodi': item.PTCodi,
          }
          
          postPreciosPaqueteLiquidacionQx(precios).then((res) => {         
            const arrayProcedimientos = res.data
    
            //calcular el precio total de los procedimientos
            const precioTotalProcedimiento = arrayProcedimientos.reduce((acumulador, { ValorBaseTarifa, ValorUnitario }) => {
              const baseTarifa = Number(ValorBaseTarifa);
              const valorUnitario = Number(ValorUnitario);
              return acumulador + (baseTarifa === 0 ? valorUnitario : baseTarifa);
            }, 0);
            setValorTotalProcedimientos(precioTotalProcedimiento)
    
            //array de los procedimientos
            const procedimientosQX = procedimientoTipoPaquete
    
            //agregar medicos
            // Recorremos el array 'arrayProcedimientos' y buscamos el objeto correspondiente en 'procedimientosQX'
            arrayProcedimientos.forEach(item => {
              // Buscamos el objeto en 'procedimientosQX' cuyo id coincida
              const encontrado = procedimientosQX.find(val => val.PRCODI.trim() === item.CodigoProcedimiento.trim());
              if (encontrado) {
                // Asignamos el valor a una nueva propiedad, por ejemplo, precioTotalProcedimiento
                item.MedCod = encontrado.MedCod;
                item.EspcCod = encontrado.EspcCod;
                item.CrgHnrCi = encontrado.CrgHnrCi;
              }
            });
                    
            //se agregan los valores por defecto a los procedimientos
            const nuevoDatosProcedimientos = arrayProcedimientos.map((item)=>{return{...item,tipoHojaFact: 'F' , agrupadorProcedimiento:'INDV', orden:1, via:'1', especilidadCirujano:'1', opcion:"1", precioTotalProcedimiento:precioTotalProcedimiento, porcentaje:100, precioPorcentajeProcedimiento: item.ValorBaseTarifa === 0? item.ValorUnitario : item.ValorBaseTarifa}})
            console.log(nuevoDatosProcedimientos, ' setDataProcedimientos')
            setDataProcedimientosPaquete(nuevoDatosProcedimientos)
            // setDataProcedimientos(res.data.data)
            // setLoadingProcedimientosPrecios(false)
            
          }
        )}, [])
   
   
    function getProcedimientosQueCoinciden(arr1, arr2) {
        // 1. Extraer y normalizar (trim + uppercase opcional) los tipos de arr2
        //    Buenas prácticas: separar responsabilidad de limpieza de datos
        const tiposBuscados = new Set(
            arr2
            .map(fila => fila.PRCODI.trim())  // eliminar espacios en los extremos
            .map(t => t.toUpperCase())       // homogeneizar mayúsculas/minúsculas (opcional)
        );

        // 2. Predicate para filtrar arr1 basándose en el Set de tipos normalizados
        function tipoCoincide(fila) {
            const tipoLimpio = fila.CrgCod.trim().toUpperCase();  
            // trim + toUpperCase mantienen consistencia con tiposBuscados
            return tiposBuscados.has(tipoLimpio);              
        }

        // 3. Filtrar arr1 con la predicate definida
        const coincidencias = arr1.filter(tipoCoincide);     

        // 4. Devolver el array resultante sin mutar los originales
        return coincidencias;
        }



    const handleClickGuardarLiquidacion=()=>{
      //console.log(procedimientosSinOrden,'procedimientosSinOrden')
      //console.log(procedimientosConOrden,'procedimientosConOrden')
      const validarTipo = dataProcedimientos.some((item)=>item.tipoHojaFact === 'seleccionar')
      
      const validarVia = dataProcedimientos.some((item)=>item.via === 'seleccionar')

      const validarEspecialidadCirujano = dataProcedimientos.some((item)=>item.especilidadCirujano === 'seleccionar')

      const validarOpcion = dataProcedimientos.some((item)=>item.opcion === 'seleccionar')

      

      const procedimientosConOrden = dataProcedimientos.reduce((contador, procedimiento) => {
        if (procedimiento.orden !== undefined) {
          return contador + 1;
        }
        return contador;
      }, 0);

      //const 
      //console.log(procedimientosConOrden,'ORDEN CANTIDAD')
      //console.log(dataProcedimientos.length,'ORDEN CANTIDAD longitud')
      //validaciones
       if(procedimientosConOrden !== 0 && dataProcedimientos.length !== procedimientosConOrden){
        setmensajeSelect('Por favor, seguir diligenciando el orden')
        setmodalOnValidarSelect(true)
      }else 
      if(validarTipo){
        setmensajeSelect('Seleccionar el tipo si es Facturable o Hoja de Gasto')
        setmodalOnValidarSelect(true)
      }else if(validarVia){
        setmensajeSelect('Seleccionar la via si es Unica via, Diferente via o Bilateral')
        setmodalOnValidarSelect(true)
      }else if(validarEspecialidadCirujano){
        setmensajeSelect('Seleccionar la especialidad del cirujano si es diferente especialidad o igual especialidad')
        setmodalOnValidarSelect(true)
      }else if(validarOpcion){
        setmensajeSelect('Seleccionar una opcion si es programa o urgencias')
        setmodalOnValidarSelect(true)
      }else{
        
        setmodalOnConfirmarLiquidacion(true)
      }     

    }

   
    

  //select tipo hoja de gasto o facturable FUNCIONA
  const handleSelectChangeTipo =(id,value) =>{    
    //asignarle a la tabla de honorarios si
    const cambiosTipo = dataPreciosTabla.map((item)=>{      
      if(parseInt(item.CodigoProcedimiento) === parseInt(id)){
        return {...item, tipoHojaFact:value}
      }
      return item
    })
    console.log(cambiosTipo,'cambiosTipo')
    setdataPreciosTabla(cambiosTipo) 
    
    
    
    //asignarle a la tabla procedimiento si es hoja de gasto o facturable FUNCIONA
    let cambiosSelectTipo = dataProcedimientos.map((item)=>{
      if(parseInt(item.CrgCod) === parseInt(id)){
        return {...item, tipoHojaFact:value }
      }
      return item
    })
    setdataProcedimientos(cambiosSelectTipo)
    console.log(cambiosSelectTipo,'cambiosSelectTipo tipo')

   
    //encontrar si algun select se encontra en 'seleccionar'
    const validarTipo = cambiosSelectTipo.some((item)=>(item.tipoHojaFact === 'seleccionar') || (item.via === 'seleccionar') || (item.especilidadCirujano === 'seleccionar') || (item.opcion === 'seleccionar')) 
    //console.log(validarTipo,'TIPO')
    if(validarTipo){
      //setmodalOnValidarSelect(true)
      setvalidarButtonDescargaPDF(true)
    }else{
      //setmodalOnValidarSelect(false)
      setvalidarButtonDescargaPDF(false)
    }

    //asignarle al PDF si es hoja de gasto o facturable FUNCIONA
    let cambiarHojaGastoOFacturableDataPrecios = dataPreciosPDF.map((item)=>{
      if(parseInt(item.CrgCod) === parseInt(id)){
        return {...item, tipoHojaFact:value }
      }
      return item
    })

    //console.log(cambiarHojaGastoOFacturableDataPrecios,'cambiarHojaGastoOFacturableDataPrecios')

    //funcion que me cambia a hoja de gasto o faturable EN LOS PRECIOS
    const cambiarHoF = cambiarHojaGastoOFacturableDataPrecios.map((item)=>{
      return {
        ...item,
        precios: item.precios.map((subItem)=>{
          if(parseInt(subItem.CodigoProcedimiento) === parseInt(id)){
            return {...subItem, tipoHojaFact:value}
          }
          return subItem
        })
      };
    });

    //console.log(cambiarHoF,'cambiarHoF')

   //funcion que vuelve a calcular el precio del procedimiento
    const volverACalcularPrecioProcedimiento = cambiarHoF.map(item => {
      const totalFacturable = item.precios
        .filter(precio => precio.tipoHojaFact === 'F')
        .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
  
      return {...item, precioProcedimiento: totalFacturable};
    });
    
    setdataPreciosPDF(volverACalcularPrecioProcedimiento)
    //console.log(volverACalcularPrecioProcedimiento,'SELECT PRECIOS')

    //calcular el total de todos los precios procedimientos qx
    let totalPreciosProcedimientos = volverACalcularPrecioProcedimiento.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
    settotalPrecioProcedimiento(totalPreciosProcedimientos)
    //console.log(totalPreciosProcedimientos,'TOTAL')
    //volver a consultar los precios en el endpoint para actualizar los precios
    const validarPrecios = cambiosSelectTipo.every((item)=>(item.tipoHojaFact !== 'seleccionar') && (item.via !== 'seleccionar') && (item.especilidadCirujano !== 'seleccionar') && (item.opcion !== 'seleccionar')) 
    if(validarPrecios){
      ///contar la cantidad undefined que tiene la orden
      const procedimientosSinOrden = cambiosSelectTipo.reduce((contador, procedimiento) => {
        if (procedimiento.orden === undefined) {
          return contador + 1;
        }
        return contador;
      }, 0);
      //con orden
      const procedimientosConOrden = cambiosSelectTipo.reduce((contador, procedimiento) => {
        if (procedimiento.orden !== undefined) {
          return contador + 1;
        }
        return contador;
      }, 0);
      ///validar si la cantidad orden es igual a la longitud a los procedimientos
      if(procedimientosSinOrden === dataProcedimientos.length){
        setloadingProcedimientosPrecios(false)
        setvalidarButtonDescargaPDF(false)
        ////////////////////////////////////////////////////////////////////////////////////////
        //primero identificar si todas los honorarios de un procedimiento qx es facturable es true
        let arrayProcedimientosFacturables = volverACalcularPrecioProcedimiento.map(procedimiento => {
          const isFacturable = procedimiento.precios.every(precio => precio.tipoHojaFact === 'F');
          return {...procedimiento, isFacturable};
        });
        

          // Segundo, ordenamos el array basado en 'isFacturable' y 'CantidadUVR'
          arrayProcedimientosFacturables.sort((a, b) => {
            if (a.isFacturable === b.isFacturable) {
                // Si ambos son facturables o ambos no son facturables, entonces ordenamos por CantidadUVR de mayor a menor
                return parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR);
            } else {
                // Si uno es facturable y el otro no, el facturable va primero
                return a.isFacturable ? -1 : 1;
            }
          });

          // Tercero, asignamos la propiedad 'orden' basado en su índice en el array
          arrayProcedimientosFacturables = arrayProcedimientosFacturables.map((procedimiento, index) => {
            return {...procedimiento, orden: index + 1};
          });

        //console.log(arrayProcedimientosFacturables,'IMPORTATEN');
        /////////////////////////////////////////////////////////////////////////////////////
        ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR CANTIDAD UVR Y AGRUPADOR////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturable = volverACalcularPrecioProcedimiento.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          multFacturable = multFacturable.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });
          //indvFacturable
          let indvFacturable = volverACalcularPrecioProcedimiento.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          indvFacturable = indvFacturable.map((obj) => {
            return { ...obj, orden: 1 };
          });

          //bilaFacturable
          let bilaFacturable = volverACalcularPrecioProcedimiento.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          bilaFacturable = bilaFacturable.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });

          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGasto = volverACalcularPrecioProcedimiento.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          multHojaGasto = multHojaGasto.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });
          //indvHojaGasto
          let indvHojaGasto = volverACalcularPrecioProcedimiento.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          indvHojaGasto = indvHojaGasto.map((obj) => {
            return { ...obj, orden: 1 };
          });
          //bilaHojaGasto
          let bilaHojaGasto = volverACalcularPrecioProcedimiento.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          bilaHojaGasto = bilaHojaGasto.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });

          let unionFacturableHojaGasto = [...multFacturable, ...indvFacturable, ...bilaFacturable, ...multHojaGasto, ...indvHojaGasto, ...bilaHojaGasto]
          console.log(unionFacturableHojaGasto,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////


        //organizar el array de mayor a menor      
        //cambiosSelectTipo.sort((a, b) => b.CantidadUVR - a.CantidadUVR  );
        //console.log(cambiosSelectTipo,'MAYORAMENORUVR')
        //asignarle el orden del mayor a menor,
        // cambiosSelectTipo = cambiosSelectTipo.map((obj, index) => {
        //   return { ...obj, orden: index + 1 };
        // });
        //console.log(cambiosSelectTipo,'DESPUES')
        /////antes ISFACTRUABLE
        //const volverAConsultarPrecios =arrayProcedimientosFacturables.map((procedimiento)=>{
          const volverAConsultarPrecios =unionFacturableHojaGasto.map((procedimiento)=>{
          return {
            codigoFormaLiquidacion:procedimiento.ForLiqCod, 
            codPortafolioProc:variablePTCODI, 
            codProcedimiento:procedimiento.CrgCod, 
            numContrato:item.ProEPS, 
            ViaProgQX:procedimiento.via, 
            EspCirProgQX: procedimiento.especilidadCirujano, 
            OpcionProgQX:procedimiento.opcion,
            NumeroOrden:`${procedimiento.orden}`,
            TipoTransaccion:procedimiento.tipoHojaFact,
            CodEmpresa:usuarioInfo.Empresa,
            CodSede:usuarioInfo.Sede,
            CodigoCirugia:item.ProCirCod,
            TipoProcQX:procedimiento.agrupadorProcedimiento
          }
        })
        const arrayOrganizadoOrden = {
          "arrayProcedimientos": volverAConsultarPrecios
        };
        console.log(volverAConsultarPrecios,'DESPUESSS')
        //endpoint para consultar los nuevo precios
        postPreciosProcedimientosLiquidacionQx(arrayOrganizadoOrden).then((ordenProcedimiento)=>{
          //console.log(res.data,'nuevo precios')
          let arraySecundarioPrecios = ordenProcedimiento.data.flat()
          //cambiar los datos al array de los precios para mostrar en el PDF
          const arrayPrincipalModificado = cambiarHoF.map(objPrincipal => {
            objPrincipal.precios = objPrincipal.precios.map(precio => {
              arraySecundarioPrecios.forEach(objSecundario => {
                if ((parseInt(precio.CodigoProcedimiento) === parseInt(objSecundario.CodigoProcedimiento)) && (precio.DescripcionHonorario === objSecundario.DescripcionHonorario)) {
                  precio.ValorHonorarioImprLiqCir = objSecundario.ValorHonorarioImprLiqCir;
                  precio.ValorHonorario = objSecundario.ValorHonorario;
                  precio.NumeroOrden = objSecundario.NumeroOrden;
                  precio.PorcOrden = objSecundario.PorcOrden;
                  precio.ValordeHonorarios= objSecundario.ValordeHonorarios;
                  precio.PorcTarifaBase = objSecundario.PorcTarifaBase;
                }
              });
              return precio;
            });
            return objPrincipal;
          });
          //volver a calcular los precios de los procedimientos
          const volverACalcularPrecioProcedimiento = arrayPrincipalModificado.map(item => {
            const totalFacturable = item.precios
              .filter(precio => precio.tipoHojaFact === 'F')
              .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
        
            return {...item, precioProcedimiento: totalFacturable};
          });
          //asignarle el orden que esta en la array de precios
          const arrayModificado = volverACalcularPrecioProcedimiento.map(item => {            
            const { NumeroOrden } = item.precios[0];
            return {...item, orden: NumeroOrden};
          });
          //arrayModificado.sort((a, b) => parseInt(b.orden) - parseInt(a.orden));
          ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR ORDEN////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvFacturable
          let indvFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //bilaFacturable
          let bilaFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvHojaGasto
          let indvHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //bilaHojaGasto
          let bilaHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         

          let unionArray = [...multFacturableOrden, ...indvFacturableOrden, ...bilaFacturableOrden, ...multHojaGastoOrden, ...indvHojaGastoOrden, ...bilaHojaGastoOrden]
          ///console.log(unionArray,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////
          setdataPreciosPDF(unionArray)  
          console.log(unionArray,'arrayModificadoarrayModificadoTIPOORDENNNNNNNNNNNNNN')
          
          let totalPreciosProcedimientos = arrayModificado.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
          settotalPrecioProcedimiento(totalPreciosProcedimientos)
          console.log(totalPreciosProcedimientos,'TOTAL')
          setTimeout(() => {          
            setloadingProcedimientosPrecios(true)
          }, 1000);  
        })
      }
      ////////////////////////////////////////CON ORDEN////////////////////////

      // const procedimientosConOrden = cambiosSelectTipo.reduce((contador, procedimiento) => {
      //   if (procedimiento.orden !== undefined) {
      //     return contador + 1;
      //   }
      //   return contador;
      // }, 0);
      //validamos que el array de procedimientos si esta completa la columna orden, si esta consultamos el endpoint para actualizar los precios
      else if(procedimientosConOrden === dataProcedimientos.length){
        setloadingProcedimientosPrecios(false)
        setvalidarButtonDescargaPDF(false)
        let volverAConsultarOrden = cambiosSelectTipo.map((procedimiento)=>{
          return{
            codigoFormaLiquidacion:procedimiento.ForLiqCod, 
            codPortafolioProc:variablePTCODI, 
            codProcedimiento:procedimiento.CrgCod, 
            numContrato:item.ProEPS, 
            ViaProgQX:procedimiento.via, 
            EspCirProgQX: procedimiento.especilidadCirujano, 
            OpcionProgQX:procedimiento.opcion, 
            NumeroOrden: procedimiento.orden,
            TipoTransaccion:procedimiento.tipoHojaFact,
            CodEmpresa:usuarioInfo.Empresa,
            CodSede:usuarioInfo.Sede,
            CodigoCirugia:item.ProCirCod,
            TipoProcQX:procedimiento.agrupadorProcedimiento
          }})
          const arrayOrganizadoOrden = {
            "arrayProcedimientos": volverAConsultarOrden
          };
          postPreciosProcedimientosLiquidacionQx(arrayOrganizadoOrden).then((orden)=>{
            let arraySecundarioPrecios = orden.data.flat()
            //cambiar los datos al array de los precios para mostrar en el PDF
            const arrayPrincipalModificado = volverACalcularPrecioProcedimiento.map(objPrincipal => {
              objPrincipal.precios = objPrincipal.precios.map(precio => {
                arraySecundarioPrecios.forEach(objSecundario => {
                  if ((parseInt(precio.CodigoProcedimiento) === parseInt(objSecundario.CodigoProcedimiento)) && (precio.DescripcionHonorario === objSecundario.DescripcionHonorario)) {
                    precio.ValorHonorarioImprLiqCir = objSecundario.ValorHonorarioImprLiqCir;
                    precio.ValorHonorario = objSecundario.ValorHonorario;
                    precio.NumeroOrden = objSecundario.NumeroOrden;
                    precio.PorcOrden = objSecundario.PorcOrden;
                    precio.ValordeHonorarios= objSecundario.ValordeHonorarios;
                    precio.PorcTarifaBase = objSecundario.PorcTarifaBase;
                  }
                });
                return precio;
              });
              return objPrincipal;
            });
            const volverACalcularPrecioProcedimientoEndpoint = arrayPrincipalModificado.map(item => {
              const totalFacturable = item.precios
                .filter(precio => precio.tipoHojaFact === 'F')
                .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
          
              return {...item, precioProcedimiento: totalFacturable};
            });
            //colocar en la variable orden el numeroOrden
            const arrayModificado = volverACalcularPrecioProcedimientoEndpoint.map(item => {
              // suponiendo que solo hay un objeto en la matriz de precios
              const { NumeroOrden } = item.precios[0];
              return {...item, orden: NumeroOrden};
            });
            //organizar de mayor a menor el 'orden'
            ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR ORDEN////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvFacturable
          let indvFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //bilaFacturable
          let bilaFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvHojaGasto
          let indvHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //bilaHojaGasto
          let bilaHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         

          let unionArray = [...multFacturableOrden, ...indvFacturableOrden, ...bilaFacturableOrden, ...multHojaGastoOrden, ...indvHojaGastoOrden, ...bilaHojaGastoOrden]
          //console.log(unionArray,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////
            setdataPreciosPDF(unionArray)  
            console.log(unionArray,'arrayModificadoarrayModificadoTIPOORDENNNNNNNNN')
            //calcular el total de todos los precios procedimientos qx
            let totalPreciosProcedimientos = arrayModificado.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
            settotalPrecioProcedimiento(totalPreciosProcedimientos)
            console.log(totalPreciosProcedimientos,'TOTAL')
            setTimeout(() => {          
            setloadingProcedimientosPrecios(true)
          }, 1000);
          })
      }else{
        setvalidarButtonDescargaPDF(true)
      }
      
    }
  }

  //select via
  const handleSelectChangeVia=(id, value)=>{
    //asignarle la via al PDF precios
    let cambiosViaPDFPrecios = dataPreciosPDF.map((item)=>{
      if(item.CrgCod === id){
        return {...item, via:value}
      }
      return item
    })
    setdataPreciosPDF(cambiosViaPDFPrecios)
    //asignarle la via al procedimiento qx
    let cambiosVia = dataProcedimientos.map((item)=>{
      if(item.CrgCod === id){
        return {...item, via:value}
      }
      return item
    })
    console.log(cambiosVia,'via')
    setdataProcedimientos(cambiosVia)
    const validarVia = cambiosVia.some((item)=>(item.tipoHojaFact === 'seleccionar') || (item.via === 'seleccionar') || (item.especilidadCirujano === 'seleccionar') || (item.opcion === 'seleccionar')) 
    //console.log(validarVia,'VIA')
    if(validarVia){
      setvalidarButtonDescargaPDF(true)
    }else{
      setvalidarButtonDescargaPDF(false)
    }

    //volver a consultar los precios en el endpoint para actualizar los precios
    const validarPrecios = cambiosVia.every((item)=>(item.tipoHojaFact !== 'seleccionar') && (item.via !== 'seleccionar') && (item.especilidadCirujano !== 'seleccionar') && (item.opcion !== 'seleccionar')) 
    if(validarPrecios){
      ///contar la cantidad undefined que tiene la orden
      const procedimientosSinOrden = cambiosVia.reduce((contador, procedimiento) => {
        if (procedimiento.orden === undefined) {
          return contador + 1;
        }
        return contador;
      }, 0);
      //con orden
      const procedimientosConOrden = cambiosVia.reduce((contador, procedimiento) => {
        if (procedimiento.orden !== undefined) {
          return contador + 1;
        }
        return contador;
      }, 0);
      ///validar si la cantidad orden es igual a la longitud a los procedimientos
      if(procedimientosSinOrden === dataProcedimientos.length){
        setloadingProcedimientosPrecios(false)
        setvalidarButtonDescargaPDF(false)
        ////////////////////////////////////////////////////////////////////////////////////////
        //primero identificar si todas los honorarios de un procedimiento qx es facturable es true
        let arrayProcedimientosFacturables = cambiosViaPDFPrecios.map(procedimiento => {
          const isFacturable = procedimiento.precios.every(precio => precio.tipoHojaFact === 'F');
          return {...procedimiento, isFacturable};
        });
        console.log(arrayProcedimientosFacturables,'ANTESSS IMPORTATEN');

          // Segundo, ordenamos el array basado en 'isFacturable' y 'CantidadUVR'
          arrayProcedimientosFacturables.sort((a, b) => {
            if (a.isFacturable === b.isFacturable) {
                // Si ambos son facturables o ambos no son facturables, entonces ordenamos por CantidadUVR de mayor a menor
                return parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR);
            } else {
                // Si uno es facturable y el otro no, el facturable va primero
                return a.isFacturable ? -1 : 1;
            }
          });

          // Tercero, asignamos la propiedad 'orden' basado en su índice en el array
          arrayProcedimientosFacturables = arrayProcedimientosFacturables.map((procedimiento, index) => {
            return {...procedimiento, orden: index + 1};
          });

        console.log(arrayProcedimientosFacturables,'IMPORTATEN');
        /////////////////////////////////////////////////////////////////////////////////////
        ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR CANTIDAD UVR Y AGRUPADOR////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturable = cambiosViaPDFPrecios.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          multFacturable = multFacturable.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });
          //indvFacturable
          let indvFacturable = cambiosViaPDFPrecios.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          indvFacturable = indvFacturable.map((obj) => {
            return { ...obj, orden: 1 };
          });

          //bilaFacturable
          let bilaFacturable = cambiosViaPDFPrecios.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          bilaFacturable = bilaFacturable.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });

          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGasto = cambiosViaPDFPrecios.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          multHojaGasto = multHojaGasto.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });
          //indvHojaGasto
          let indvHojaGasto = cambiosViaPDFPrecios.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          indvHojaGasto = indvHojaGasto.map((obj) => {
            return { ...obj, orden: 1 };
          });
          //bilaHojaGasto
          let bilaHojaGasto = cambiosViaPDFPrecios.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          bilaHojaGasto = bilaHojaGasto.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });

          let unionFacturableHojaGasto = [...multFacturable, ...indvFacturable, ...bilaFacturable, ...multHojaGasto, ...indvHojaGasto, ...bilaHojaGasto]
          console.log(unionFacturableHojaGasto,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////fin/////////////////////////////////////////////////////////////////////


        //organizar el array de mayor a menor      
        //cambiosVia.sort((a, b) => b.CantidadUVR - a.CantidadUVR  );
        //console.log(cambiosSelectTipo,'MAYORAMENORUVR')
        //asignarle el orden del mayor a menor,
        // cambiosVia = cambiosVia.map((obj, index) => {
        //   return { ...obj, orden: index + 1 };
        // });
        const volverAConsultarPrecios =unionFacturableHojaGasto.map((procedimiento)=>{
          return {
            codigoFormaLiquidacion:procedimiento.ForLiqCod, 
            codPortafolioProc:variablePTCODI, 
            codProcedimiento:procedimiento.CrgCod, 
            numContrato:item.ProEPS, 
            ViaProgQX:procedimiento.via, 
            EspCirProgQX: procedimiento.especilidadCirujano, 
            OpcionProgQX:procedimiento.opcion,
            NumeroOrden:`${procedimiento.orden}`,
            TipoTransaccion:procedimiento.tipoHojaFact,
            CodEmpresa:usuarioInfo.Empresa,
            CodSede:usuarioInfo.Sede,
            CodigoCirugia:item.ProCirCod,
            TipoProcQX:procedimiento.agrupadorProcedimiento
          }
        })
        const arrayOrganizadoOrden = {
          "arrayProcedimientos": volverAConsultarPrecios
        };
        //endpoint para consultar los nuevo precios
        postPreciosProcedimientosLiquidacionQx(arrayOrganizadoOrden).then((ordenProcedimiento)=>{
          let arraySecundarioPrecios = ordenProcedimiento.data.flat()
          const arrayPrincipalModificado = arrayProcedimientosFacturables.map(objPrincipal => {
            objPrincipal.precios = objPrincipal.precios.map(precio => {
              arraySecundarioPrecios.forEach(objSecundario => {
                if ((parseInt(precio.CodigoProcedimiento) === parseInt(objSecundario.CodigoProcedimiento)) && (precio.DescripcionHonorario === objSecundario.DescripcionHonorario)) {
                  precio.ValorHonorarioImprLiqCir = objSecundario.ValorHonorarioImprLiqCir;
                  precio.ValorHonorario = objSecundario.ValorHonorario;
                  precio.NumeroOrden = objSecundario.NumeroOrden;
                  precio.PorcOrden = objSecundario.PorcOrden;
                  precio.ValordeHonorarios= objSecundario.ValordeHonorarios;
                  precio.PorcTarifaBase = objSecundario.PorcTarifaBase;
                }
              });
              return precio;
            });
            return objPrincipal;
          });
          //volver a calcular los precios de los procedimientos
          const volverACalcularPrecioProcedimiento = arrayPrincipalModificado.map(item => {
            const totalFacturable = item.precios
              .filter(precio => precio.tipoHojaFact === 'F')
              .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
        
            return {...item, precioProcedimiento: totalFacturable};
          });
          //asignarle el orden que esta en la array de precios
          const arrayModificado = volverACalcularPrecioProcedimiento.map(item => {            
            const { NumeroOrden } = item.precios[0];
            return {...item, orden: NumeroOrden};
          });
          //arrayModificado.sort((a, b) => parseInt(b.orden) - parseInt(a.orden));
          ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR ORDEN////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvFacturable
          let indvFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //bilaFacturable
          let bilaFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvHojaGasto
          let indvHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //bilaHojaGasto
          let bilaHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         

          let unionArray = [...multFacturableOrden, ...indvFacturableOrden, ...bilaFacturableOrden, ...multHojaGastoOrden, ...indvHojaGastoOrden, ...bilaHojaGastoOrden]
          ///console.log(unionArray,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////
          setdataPreciosPDF(unionArray)  
          console.log(unionArray,'arrayModificadoarrayModificadoVIAORDENNNNN')
          
          let totalPreciosProcedimientos = arrayModificado.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
          settotalPrecioProcedimiento(totalPreciosProcedimientos)
          console.log(totalPreciosProcedimientos,'TOTAL')
          setTimeout(() => {          
            setloadingProcedimientosPrecios(true)
          }, 1000);    
        })
      }

      // const procedimientosConOrden = cambiosVia.reduce((contador, procedimiento) => {
      //   if (procedimiento.orden !== undefined) {
      //     return contador + 1;
      //   }
      //   return contador;
      // }, 0);
      //validamos que el array de procedimientos si esta completa la columna orden, si esta consultamos el endpoint para actualizar los precios
      else if(procedimientosConOrden === dataProcedimientos.length){
        setloadingProcedimientosPrecios(false)
        setvalidarButtonDescargaPDF(false)
        let volverAConsultarOrden = cambiosVia.map((procedimiento)=>{
          return{
            codigoFormaLiquidacion:procedimiento.ForLiqCod, 
            codPortafolioProc:variablePTCODI, 
            codProcedimiento:procedimiento.CrgCod, 
            numContrato:item.ProEPS, 
            ViaProgQX:procedimiento.via, 
            EspCirProgQX: procedimiento.especilidadCirujano, 
            OpcionProgQX:procedimiento.opcion, 
            NumeroOrden: procedimiento.orden,
            TipoTransaccion:procedimiento.tipoHojaFact,
            CodEmpresa:usuarioInfo.Empresa,
            CodSede:usuarioInfo.Sede,
            CodigoCirugia:item.ProCirCod,
            TipoProcQX:procedimiento.agrupadorProcedimiento
          }})
          const arrayOrganizadoOrden = {
            "arrayProcedimientos": volverAConsultarOrden
          };
          postPreciosProcedimientosLiquidacionQx(arrayOrganizadoOrden).then((ordenProcedimiento)=>{
            let arraySecundarioPrecios = ordenProcedimiento.data.flat()
            const arrayPrincipalModificado = cambiosViaPDFPrecios.map(objPrincipal => {
              objPrincipal.precios = objPrincipal.precios.map(precio => {
                arraySecundarioPrecios.forEach(objSecundario => {
                  if ((parseInt(precio.CodigoProcedimiento) === parseInt(objSecundario.CodigoProcedimiento)) && (precio.DescripcionHonorario === objSecundario.DescripcionHonorario)) {
                    precio.ValorHonorarioImprLiqCir = objSecundario.ValorHonorarioImprLiqCir;
                    precio.ValorHonorario = objSecundario.ValorHonorario;
                    precio.NumeroOrden = objSecundario.NumeroOrden;
                    precio.PorcOrden = objSecundario.PorcOrden;
                    precio.ValordeHonorarios= objSecundario.ValordeHonorarios;
                    precio.PorcTarifaBase = objSecundario.PorcTarifaBase;
                  }
                });
                return precio;
              });
              return objPrincipal;
            });
            const volverACalcularPrecioProcedimiento = arrayPrincipalModificado.map(item => {
              const totalFacturable = item.precios
                .filter(precio => precio.tipoHojaFact === 'F')
                .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
          
              return {...item, precioProcedimiento: totalFacturable};
            });
            //colocar en la variable orden el numeroOrden
            const arrayModificado = volverACalcularPrecioProcedimiento.map(item => {
              // suponiendo que solo hay un objeto en la matriz de precios
              const { NumeroOrden } = item.precios[0];
              return {...item, orden: NumeroOrden};
            });
            //organizar de mayor a menor el 'orden'
            ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR ORDEN////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvFacturable
          let indvFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //bilaFacturable
          let bilaFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvHojaGasto
          let indvHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //bilaHojaGasto
          let bilaHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         

          let unionArray = [...multFacturableOrden, ...indvFacturableOrden, ...bilaFacturableOrden, ...multHojaGastoOrden, ...indvHojaGastoOrden, ...bilaHojaGastoOrden]
          ///console.log(unionArray,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////
            setdataPreciosPDF(unionArray)  
            console.log(unionArray,'arrayModificadoarrayModificadoVIAORDENNNN')
            //calcular el total de todos los precios procedimientos qx
            let totalPreciosProcedimientos = arrayModificado.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
            settotalPrecioProcedimiento(totalPreciosProcedimientos)
            console.log(totalPreciosProcedimientos,'TOTAL')
            setTimeout(() => {          
            setloadingProcedimientosPrecios(true)
          }, 1000);     
          })
      }else{
        setvalidarButtonDescargaPDF(true)
      }
    }
  }

  const handleSelectChangeEspecialidadCirujano = (id, value) =>{   
    //asignarle si es igual especialidad o difirente especialidad en PDF
    let cambiosEspecialidadPDFPrecios = dataPreciosPDF.map((item)=>{
      if(parseInt(item.CrgCod) === parseInt(id)){
        return {...item, especilidadCirujano:value}
      }
      return item
    }) 
    setdataPreciosPDF(cambiosEspecialidadPDFPrecios)
    //asignarle si es igual especialidad o difirente especialidad
    let cambiosEspecialidad = dataProcedimientos.map((item)=>{
      if(parseInt(item.CrgCod) === parseInt(id)){
        return {...item, especilidadCirujano:value}
      }
      return item
    })
    //console.log(cambiosEspecialidad,'cambiosEspecialidad')
    setdataProcedimientos(cambiosEspecialidad)
    const validarEspecialidadCirujano = cambiosEspecialidad.some((item)=>(item.tipoHojaFact === 'seleccionar') || (item.via === 'seleccionar') || (item.especilidadCirujano === 'seleccionar') || (item.opcion === 'seleccionar')) 
    if(validarEspecialidadCirujano){
      setvalidarButtonDescargaPDF(true)
    }else{
      setvalidarButtonDescargaPDF(false)
    }

    //volver a consultar los precios en el endpoint para actualizar los precios
    const validarPrecios = cambiosEspecialidad.every((item)=>(item.tipoHojaFact !== 'seleccionar') && (item.via !== 'seleccionar') && (item.especilidadCirujano !== 'seleccionar') && (item.opcion !== 'seleccionar')) 
    if(validarPrecios){
      ///contar la cantidad undefined que tiene la orden
      const procedimientosSinOrden = cambiosEspecialidad.reduce((contador, procedimiento) => {
        if (procedimiento.orden === undefined) {
          return contador + 1;
        }
        return contador;
      }, 0);
      //con orden
      const procedimientosConOrden = cambiosEspecialidad.reduce((contador, procedimiento) => {
        if (procedimiento.orden !== undefined) {
          return contador + 1;
        }
        return contador;
      }, 0);
      ///validar si la cantidad orden es igual a la longitud a los procedimientos
      if(procedimientosSinOrden === dataProcedimientos.length){
        setloadingProcedimientosPrecios(false)
        setvalidarButtonDescargaPDF(false)
        ////////////////////////////////////////////////////////////////////////////////////////
        //primero identificar si todas los honorarios de un procedimiento qx es facturable es true
        let arrayProcedimientosFacturables = cambiosEspecialidadPDFPrecios.map(procedimiento => {
          const isFacturable = procedimiento.precios.every(precio => precio.tipoHojaFact === 'F');
          return {...procedimiento, isFacturable};
        });
        

          // Segundo, ordenamos el array basado en 'isFacturable' y 'CantidadUVR'
          arrayProcedimientosFacturables.sort((a, b) => {
            if (a.isFacturable === b.isFacturable) {
                // Si ambos son facturables o ambos no son facturables, entonces ordenamos por CantidadUVR de mayor a menor
                return parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR);
            } else {
                // Si uno es facturable y el otro no, el facturable va primero
                return a.isFacturable ? -1 : 1;
            }
          });

          // Tercero, asignamos la propiedad 'orden' basado en su índice en el array
          arrayProcedimientosFacturables = arrayProcedimientosFacturables.map((procedimiento, index) => {
            return {...procedimiento, orden: index + 1};
          });

        console.log(arrayProcedimientosFacturables,'IMPORTATEN');
        /////////////////////////////////////////////////////////////////////////////////////
        ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR CANTIDAD UVR Y AGRUPADOR////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturable = cambiosEspecialidadPDFPrecios.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          multFacturable = multFacturable.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });
          //indvFacturable
          let indvFacturable = cambiosEspecialidadPDFPrecios.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          indvFacturable = indvFacturable.map((obj) => {
            return { ...obj, orden: 1 };
          });

          //bilaFacturable
          let bilaFacturable = cambiosEspecialidadPDFPrecios.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          bilaFacturable = bilaFacturable.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });

          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGasto = cambiosEspecialidadPDFPrecios.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          multHojaGasto = multHojaGasto.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });
          //indvHojaGasto
          let indvHojaGasto = cambiosEspecialidadPDFPrecios.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          indvHojaGasto = indvHojaGasto.map((obj) => {
            return { ...obj, orden: 1 };
          });
          //bilaHojaGasto
          let bilaHojaGasto = cambiosEspecialidadPDFPrecios.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          bilaHojaGasto = bilaHojaGasto.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });

          let unionFacturableHojaGasto = [...multFacturable, ...indvFacturable, ...bilaFacturable, ...multHojaGasto, ...indvHojaGasto, ...bilaHojaGasto]
          console.log(unionFacturableHojaGasto,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////

        //organizar el array de mayor a menor      
        //cambiosEspecialidad.sort((a, b) => b.CantidadUVR - a.CantidadUVR  );
        //asignarle el orden del mayor a menor,
        // cambiosEspecialidad = cambiosEspecialidad.map((obj, index) => {
        //   return { ...obj, orden: index + 1 };
        // });
        const volverAConsultarPrecios =unionFacturableHojaGasto.map((procedimiento)=>{
          return {
            codigoFormaLiquidacion:procedimiento.ForLiqCod, 
            codPortafolioProc:variablePTCODI, 
            codProcedimiento:procedimiento.CrgCod, 
            numContrato:item.ProEPS, 
            ViaProgQX:procedimiento.via, 
            EspCirProgQX: procedimiento.especilidadCirujano, 
            OpcionProgQX:procedimiento.opcion,
            NumeroOrden:`${procedimiento.orden}`,
            TipoTransaccion:procedimiento.tipoHojaFact,
            CodEmpresa:usuarioInfo.Empresa,
            CodSede:usuarioInfo.Sede,
            CodigoCirugia:item.ProCirCod,
            TipoProcQX:procedimiento.agrupadorProcedimiento
          }
        })
        const arrayOrganizadoOrden = {
          "arrayProcedimientos": volverAConsultarPrecios
        };
        //endpoint para consultar los nuevo precios
        postPreciosProcedimientosLiquidacionQx(arrayOrganizadoOrden).then((ordenProcedimiento)=>{
          let arraySecundarioPrecios = ordenProcedimiento.data.flat()
          const arrayPrincipalModificado = arrayProcedimientosFacturables.map(objPrincipal => {
            objPrincipal.precios = objPrincipal.precios.map(precio => {
              arraySecundarioPrecios.forEach(objSecundario => {
                if ((parseInt(precio.CodigoProcedimiento) === parseInt(objSecundario.CodigoProcedimiento)) && (precio.DescripcionHonorario === objSecundario.DescripcionHonorario)) {
                  precio.ValorHonorarioImprLiqCir = objSecundario.ValorHonorarioImprLiqCir;
                  precio.ValorHonorario = objSecundario.ValorHonorario;
                  precio.NumeroOrden = objSecundario.NumeroOrden;
                  precio.PorcOrden = objSecundario.PorcOrden;
                  precio.ValordeHonorarios= objSecundario.ValordeHonorarios;
                  precio.PorcTarifaBase = objSecundario.PorcTarifaBase;
                }
              });
              return precio;
            });
            return objPrincipal;
          });
          //volver a calcular los precios de los procedimientos
          const volverACalcularPrecioProcedimiento = arrayPrincipalModificado.map(item => {
            const totalFacturable = item.precios
              .filter(precio => precio.tipoHojaFact === 'F')
              .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
        
            return {...item, precioProcedimiento: totalFacturable};
          });
          //asignarle el orden que esta en la array de precios
          const arrayModificado = volverACalcularPrecioProcedimiento.map(item => {            
            const { NumeroOrden } = item.precios[0];
            return {...item, orden: NumeroOrden};
          });
          //arrayModificado.sort((a, b) => parseInt(b.orden) - parseInt(a.orden));
          ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR ORDEN////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvFacturable
          let indvFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //bilaFacturable
          let bilaFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvHojaGasto
          let indvHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //bilaHojaGasto
          let bilaHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         

          let unionArray = [...multFacturableOrden, ...indvFacturableOrden, ...bilaFacturableOrden, ...multHojaGastoOrden, ...indvHojaGastoOrden, ...bilaHojaGastoOrden]
          ///console.log(unionArray,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////
          
          setdataPreciosPDF(unionArray)  
          console.log(unionArray,'arrayModificadoarrayModificadoESPECIALIDADORDENNN')
          
          let totalPreciosProcedimientos = arrayModificado.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
          settotalPrecioProcedimiento(totalPreciosProcedimientos)
          console.log(totalPreciosProcedimientos,'TOTAL')
          setTimeout(() => {          
            setloadingProcedimientosPrecios(true)
          }, 1000);     
        })
      }

      // const procedimientosConOrden = cambiosEspecialidad.reduce((contador, procedimiento) => {
      //   if (procedimiento.orden !== undefined) {
      //     return contador + 1;
      //   }
      //   return contador;
      // }, 0);
      //validamos que el array de procedimientos si esta completa la columna orden, si esta consultamos el endpoint para actualizar los precios
      else if(procedimientosConOrden === dataProcedimientos.length){
        setloadingProcedimientosPrecios(false)
        setvalidarButtonDescargaPDF(false)
        let volverAConsultarOrden = cambiosEspecialidad.map((procedimiento)=>{
          return{
            codigoFormaLiquidacion:procedimiento.ForLiqCod, 
            codPortafolioProc:variablePTCODI, 
            codProcedimiento:procedimiento.CrgCod, 
            numContrato:item.ProEPS, 
            ViaProgQX:procedimiento.via, 
            EspCirProgQX: procedimiento.especilidadCirujano, 
            OpcionProgQX:procedimiento.opcion, 
            NumeroOrden: procedimiento.orden,
            TipoTransaccion:procedimiento.tipoHojaFact,
            CodEmpresa:usuarioInfo.Empresa,
            CodSede:usuarioInfo.Sede,
            CodigoCirugia:item.ProCirCod,
            TipoProcQX:procedimiento.agrupadorProcedimiento
          }})
          const arrayOrganizadoOrden = {
            "arrayProcedimientos": volverAConsultarOrden
          };
          postPreciosProcedimientosLiquidacionQx(arrayOrganizadoOrden).then((orden)=>{
            let arraySecundarioPrecios = orden.data.flat()
            //cambiar los datos al array de los precios para mostrar en el PDF
            const arrayPrincipalModificado = cambiosEspecialidadPDFPrecios.map(objPrincipal => {
              objPrincipal.precios = objPrincipal.precios.map(precio => {
                arraySecundarioPrecios.forEach(objSecundario => {
                  if ((parseInt(precio.CodigoProcedimiento) === parseInt(objSecundario.CodigoProcedimiento)) && (precio.DescripcionHonorario === objSecundario.DescripcionHonorario)) {
                    precio.ValorHonorarioImprLiqCir = objSecundario.ValorHonorarioImprLiqCir;
                    precio.ValorHonorario = objSecundario.ValorHonorario;
                    precio.NumeroOrden = objSecundario.NumeroOrden;
                    precio.PorcOrden = objSecundario.PorcOrden;
                    precio.ValordeHonorarios= objSecundario.ValordeHonorarios;
                    precio.PorcTarifaBase = objSecundario.PorcTarifaBase;
                  }
                });
                return precio;
              });
              return objPrincipal;
            });
            const volverACalcularPrecioProcedimiento = arrayPrincipalModificado.map(item => {
              const totalFacturable = item.precios
                .filter(precio => precio.tipoHojaFact === 'F')
                .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
          
              return {...item, precioProcedimiento: totalFacturable};
            });
            //colocar en la variable orden el numeroOrden
            const arrayModificado = volverACalcularPrecioProcedimiento.map(item => {
              // suponiendo que solo hay un objeto en la matriz de precios
              const { NumeroOrden } = item.precios[0];
              return {...item, orden: NumeroOrden};
            });
            //organizar de mayor a menor el 'orden'
            ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR ORDEN////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvFacturable
          let indvFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //bilaFacturable
          let bilaFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvHojaGasto
          let indvHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //bilaHojaGasto
          let bilaHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         

          let unionArray = [...multFacturableOrden, ...indvFacturableOrden, ...bilaFacturableOrden, ...multHojaGastoOrden, ...indvHojaGastoOrden, ...bilaHojaGastoOrden]
          ///console.log(unionArray,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////
            //arrayModificado.sort((a, b) => parseInt(b.orden) - parseInt(a.orden));
            setdataPreciosPDF(unionArray)  
            console.log(unionArray,'arrayModificadoarrayModificadoESPECIALIDADORDENNNNN')
            //calcular el total de todos los precios procedimientos qx
            let totalPreciosProcedimientos = arrayModificado.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
            settotalPrecioProcedimiento(totalPreciosProcedimientos)
            console.log(totalPreciosProcedimientos,'TOTAL')
            setTimeout(() => {          
            setloadingProcedimientosPrecios(true)
          }, 1000);  
          })
      }else{
        setvalidarButtonDescargaPDF(true)
      }
    }
  }

  const handleSelectChangeOpcion = (id, value) =>{
    //asignarle opcion si es programa o urgencias
    let cambiosOpcionPDF = dataPreciosPDF.map((item)=>{
      if(parseInt(item.CrgCod) === parseInt(id)){
        return {...item, opcion:value}
      }
      return item
    })
    setdataPreciosPDF(cambiosOpcionPDF)
    //asignarle opcion si es programa o urgencias
    let cambiosOpcion = dataProcedimientos.map((item)=>{
      if(parseInt(item.CrgCod) === parseInt(id)){
        return {...item, opcion:value}
      }
      return item
    })
    //console.log(cambiosOpcion,'cambiosOpcion')
    setdataProcedimientos(cambiosOpcion)

    //validamos el select opcion que sea diferente a 'seleccionar'
    const validarOpcion = cambiosOpcion.some((item)=>(item.tipoHojaFact === 'seleccionar') || (item.via === 'seleccionar') || (item.especilidadCirujano === 'seleccionar') || (item.opcion === 'seleccionar')) 
    if(validarOpcion){
      setvalidarButtonDescargaPDF(true)
    }else{
      setvalidarButtonDescargaPDF(false)
    }

    //volver a consultar los precios en el endpoint para actualizar los precios
    const validarPrecios = cambiosOpcion.every((item)=>(item.tipoHojaFact !== 'seleccionar') && (item.via !== 'seleccionar') && (item.especilidadCirujano !== 'seleccionar') && (item.opcion !== 'seleccionar')) 
    if(validarPrecios){
      ///contar la cantidad undefined que tiene la orden
      const procedimientosSinOrden = cambiosOpcion.reduce((contador, procedimiento) => {
        if (procedimiento.orden === undefined) {
          return contador + 1;
        }
        return contador;
      }, 0);
      //con orden
      const procedimientosConOrden = cambiosOpcion.reduce((contador, procedimiento) => {
        if (procedimiento.orden !== undefined) {
          return contador + 1;
        }
        return contador;
      }, 0);
      ///validar si la cantidad orden es igual a la longitud a los procedimientos
      if(procedimientosSinOrden === dataProcedimientos.length){
        setloadingProcedimientosPrecios(false)
        setvalidarButtonDescargaPDF(false)

        ////////////////////////////////////////////////////////////////////////////////////////
        //primero identificar si todas los honorarios de un procedimiento qx es facturable es true
        let arrayProcedimientosFacturables = cambiosOpcionPDF.map(procedimiento => {
          const isFacturable = procedimiento.precios.every(precio => precio.tipoHojaFact === 'F');
          return {...procedimiento, isFacturable};
        });
        

          // Segundo, ordenamos el array basado en 'isFacturable' y 'CantidadUVR'
          arrayProcedimientosFacturables.sort((a, b) => {
            if (a.isFacturable === b.isFacturable) {
                // Si ambos son facturables o ambos no son facturables, entonces ordenamos por CantidadUVR de mayor a menor
                return parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR);
            } else {
                // Si uno es facturable y el otro no, el facturable va primero
                return a.isFacturable ? -1 : 1;
            }
          });

          // Tercero, asignamos la propiedad 'orden' basado en su índice en el array
          arrayProcedimientosFacturables = arrayProcedimientosFacturables.map((procedimiento, index) => {
            return {...procedimiento, orden: index + 1};
          });

        console.log(arrayProcedimientosFacturables,'IMPORTATEN');
        /////////////////////////////////////////////////////////////////////////////////////
        ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR CANTIDAD UVR Y AGRUPADOR////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturable = cambiosOpcionPDF.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          multFacturable = multFacturable.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });
          //indvFacturable
          let indvFacturable = cambiosOpcionPDF.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          indvFacturable = indvFacturable.map((obj) => {
            return { ...obj, orden: 1 };
          });

          //bilaFacturable
          let bilaFacturable = cambiosOpcionPDF.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          bilaFacturable = bilaFacturable.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });

          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGasto = cambiosOpcionPDF.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          multHojaGasto = multHojaGasto.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });
          //indvHojaGasto
          let indvHojaGasto = cambiosOpcionPDF.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          indvHojaGasto = indvHojaGasto.map((obj) => {
            return { ...obj, orden: 1 };
          });
          //bilaHojaGasto
          let bilaHojaGasto = cambiosOpcionPDF.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
          bilaHojaGasto = bilaHojaGasto.map((obj, index) => {
            return { ...obj, orden: index + 1 };
          });

          let unionFacturableHojaGasto = [...multFacturable, ...indvFacturable, ...bilaFacturable, ...multHojaGasto, ...indvHojaGasto, ...bilaHojaGasto]
          console.log(unionFacturableHojaGasto,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////


        //organizar el array de mayor a menor      
        //cambiosOpcion.sort((a, b) => b.CantidadUVR - a.CantidadUVR  );
        //asignarle el orden del mayor a menor,
        // cambiosOpcion = cambiosOpcion.map((obj, index) => {
        //   return { ...obj, orden: index + 1 };
        // });
        const volverAConsultarPrecios =unionFacturableHojaGasto.map((procedimiento)=>{
          return {
            codigoFormaLiquidacion:procedimiento.ForLiqCod, 
            codPortafolioProc:variablePTCODI, 
            codProcedimiento:procedimiento.CrgCod, 
            numContrato:item.ProEPS, 
            ViaProgQX:procedimiento.via, 
            EspCirProgQX: procedimiento.especilidadCirujano, 
            OpcionProgQX:procedimiento.opcion,
            NumeroOrden:`${procedimiento.orden}`,
            TipoTransaccion:procedimiento.tipoHojaFact,
            CodEmpresa:usuarioInfo.Empresa,
            CodSede:usuarioInfo.Sede,
            CodigoCirugia:item.ProCirCod,
            TipoProcQX:procedimiento.agrupadorProcedimiento
          }
        })
        const arrayOrganizadoOrden = {
          "arrayProcedimientos": volverAConsultarPrecios
        };

        //endpoint para consultar los nuevo precios
        postPreciosProcedimientosLiquidacionQx(arrayOrganizadoOrden).then((ordenProcedimiento)=>{
          let arraySecundarioPrecios = ordenProcedimiento.data.flat()
          //cambiar los datos al array de los precios para mostrar en el PDF
          const arrayPrincipalModificado = arrayProcedimientosFacturables.map(objPrincipal => {
            objPrincipal.precios = objPrincipal.precios.map(precio => {
              arraySecundarioPrecios.forEach(objSecundario => {
                if ((parseInt(precio.CodigoProcedimiento) === parseInt(objSecundario.CodigoProcedimiento)) && (precio.DescripcionHonorario === objSecundario.DescripcionHonorario)) {
                  precio.ValorHonorarioImprLiqCir = objSecundario.ValorHonorarioImprLiqCir;
                  precio.ValorHonorario = objSecundario.ValorHonorario;
                  precio.NumeroOrden = objSecundario.NumeroOrden;
                  precio.PorcOrden = objSecundario.PorcOrden;
                  precio.ValordeHonorarios= objSecundario.ValordeHonorarios;
                  precio.PorcTarifaBase = objSecundario.PorcTarifaBase;
                }
              });
              return precio;
            });
            return objPrincipal;
          });
          //volver a calcular los precios de los procedimientos
          const volverACalcularPrecioProcedimiento = arrayPrincipalModificado.map(item => {
            const totalFacturable = item.precios
              .filter(precio => precio.tipoHojaFact === 'F')
              .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
        
            return {...item, precioProcedimiento: totalFacturable};
          });
          //asignarle el orden que esta en la array de precios
          const arrayModificado = volverACalcularPrecioProcedimiento.map(item => {            
            const { NumeroOrden } = item.precios[0];
            return {...item, orden: NumeroOrden};
          });
          //arrayModificado.sort((a, b) => parseInt(b.orden) - parseInt(a.orden));
          ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR ORDEN////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvFacturable
          let indvFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //bilaFacturable
          let bilaFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvHojaGasto
          let indvHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //bilaHojaGasto
          let bilaHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         

          let unionArray = [...multFacturableOrden, ...indvFacturableOrden, ...bilaFacturableOrden, ...multHojaGastoOrden, ...indvHojaGastoOrden, ...bilaHojaGastoOrden]
          ///console.log(unionArray,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////
          setdataPreciosPDF(unionArray)  
          console.log(unionArray,'arrayModificadoarrayModificadoOPCIONORDENNNNNNN')
          
          let totalPreciosProcedimientos = arrayModificado.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
          settotalPrecioProcedimiento(totalPreciosProcedimientos)
          console.log(totalPreciosProcedimientos,'TOTAL')
           setTimeout(() => {          
            setloadingProcedimientosPrecios(true)
          }, 1000);  
        })
      }


      // const procedimientosConOrden = cambiosOpcion.reduce((contador, procedimiento) => {
      //   if (procedimiento.orden !== undefined) {
      //     return contador + 1;
      //   }
      //   return contador;
      // }, 0);
       //validamos que el array de procedimientos si esta completa la columna orden, si esta consultamos el endpoint para actualizar los precios
      else if(procedimientosConOrden === dataProcedimientos.length){
        setloadingProcedimientosPrecios(false)
        setvalidarButtonDescargaPDF(false)
        let volverAConsultarOrden = cambiosOpcion.map((procedimiento)=>{
          return{
            codigoFormaLiquidacion:procedimiento.ForLiqCod, 
            codPortafolioProc:variablePTCODI, 
            codProcedimiento:procedimiento.CrgCod, 
            numContrato:item.ProEPS, 
            ViaProgQX:procedimiento.via, 
            EspCirProgQX: procedimiento.especilidadCirujano, 
            OpcionProgQX:procedimiento.opcion, 
            NumeroOrden: procedimiento.orden,
            TipoTransaccion:procedimiento.tipoHojaFact,
            CodEmpresa:usuarioInfo.Empresa,
            CodSede:usuarioInfo.Sede,
            CodigoCirugia:item.ProCirCod,
            TipoProcQX:procedimiento.agrupadorProcedimiento
          }})
          const arrayOrganizadoOrden = {
            "arrayProcedimientos": volverAConsultarOrden
          };
          postPreciosProcedimientosLiquidacionQx(arrayOrganizadoOrden).then((orden)=>{
            let arraySecundarioPrecios = orden.data.flat()
            //cambiar los datos al array de los precios para mostrar en el PDF
            const arrayPrincipalModificado = cambiosOpcionPDF.map(objPrincipal => {
              objPrincipal.precios = objPrincipal.precios.map(precio => {
                arraySecundarioPrecios.forEach(objSecundario => {
                  if ((parseInt(precio.CodigoProcedimiento) === parseInt(objSecundario.CodigoProcedimiento)) && (precio.DescripcionHonorario === objSecundario.DescripcionHonorario)) {
                    precio.ValorHonorarioImprLiqCir = objSecundario.ValorHonorarioImprLiqCir;
                    precio.ValorHonorario = objSecundario.ValorHonorario;
                    precio.NumeroOrden = objSecundario.NumeroOrden;
                    precio.PorcOrden = objSecundario.PorcOrden;
                    precio.ValordeHonorarios= objSecundario.ValordeHonorarios;
                    precio.PorcTarifaBase = objSecundario.PorcTarifaBase;
                  }
                });
                return precio;
              });
              return objPrincipal;
            });
            const volverACalcularPrecioProcedimiento = arrayPrincipalModificado.map(item => {
              const totalFacturable = item.precios
                .filter(precio => precio.tipoHojaFact === 'F')
                .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
          
              return {...item, precioProcedimiento: totalFacturable};
            });
            //colocar en la variable orden el numeroOrden
            const arrayModificado = volverACalcularPrecioProcedimiento.map(item => {
              // suponiendo que solo hay un objeto en la matriz de precios
              const { NumeroOrden } = item.precios[0];
              return {...item, orden: NumeroOrden};
            });
            //organizar de mayor a menor el 'orden'
            ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR ORDEN////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvFacturable
          let indvFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //bilaFacturable
          let bilaFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvHojaGasto
          let indvHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //bilaHojaGasto
          let bilaHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         

          let unionArray = [...multFacturableOrden, ...indvFacturableOrden, ...bilaFacturableOrden, ...multHojaGastoOrden, ...indvHojaGastoOrden, ...bilaHojaGastoOrden]
          ///console.log(unionArray,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////
            setdataPreciosPDF(unionArray)  
            console.log(unionArray,'arrayModificadoarrayModificadoOPCIONORDENNNN')
            //calcular el total de todos los precios procedimientos qx
            let totalPreciosProcedimientos = arrayModificado.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
            settotalPrecioProcedimiento(totalPreciosProcedimientos)
            console.log(totalPreciosProcedimientos,'TOTAL')
            setTimeout(() => {          
              setloadingProcedimientosPrecios(true)
          }, 1000);  
          })
      }else{
        setvalidarButtonDescargaPDF(true)
      }
    }

  }

  const handleCheckboxChangeIsFacturable=(id,nombreHonorario)=>{
    //console.log(dataPreciosPDF,'dataPreciosPDF chebox')
    //console.log(nombreHonorario,'nombreHonorario')
    const cambiarTipo = dataPreciosTabla.map((item)=>{
      if((parseInt(item.CodigoProcedimiento) === parseInt(id)) && (nombreHonorario === item.DescripcionHonorario)){
        return {...item, tipoHojaFact: item.tipoHojaFact === 'H'? 'F':'H'}
      }
      return item
    })
    setdataPreciosTabla(cambiarTipo)

    const cambiarHoF = dataPreciosPDF.map((item)=>{
      return {
        ...item,
        precios: item.precios.map((subItem)=>{
          if((parseInt(subItem.CodigoProcedimiento) === parseInt(id)) && (nombreHonorario === subItem.DescripcionHonorario)){
            return {...subItem, tipoHojaFact: subItem.tipoHojaFact === 'H'? 'F':'H'}
          }
          return subItem
        })
      };
    });

    const volverACalcularPrecioProcedimiento = cambiarHoF.map(item => {
      const totalFacturable = item.precios
        .filter(precio => precio.tipoHojaFact === 'F')
        .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
  
      return {...item, precioProcedimiento: totalFacturable};
    });
    //console.log(volverACalcularPrecioProcedimiento,'checkbox PRECIO')
    setdataPreciosPDF(volverACalcularPrecioProcedimiento)

    //calcular el total de todos los precios procedimientos qx
    let totalPreciosProcedimientos = volverACalcularPrecioProcedimiento.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
    settotalPrecioProcedimiento(totalPreciosProcedimientos)
    console.log(totalPreciosProcedimientos,'TOTAL')
  }

  //Esta funcion me permite llamar y validar el endpoint para actualizar los precios del PDF
  const handleChangeOrden =(e,id)=>{
     //console.log(e.target.value,'evento')
    // console.log(id,'id cirugia')
    //console.log(procedimientosSinOrden,'procedimientosSinOrden antes')
    let dataInput = e.target.value
    if(dataInput){
      dataInput = e.target.value
    }else{
      dataInput = undefined
    }
    //console.log(dataInput,'INPUT')
    let cambiarOrden = dataProcedimientos.map((item)=>{
      if(parseInt(item.CrgCod) === parseInt(id)){
        return {...item, orden:dataInput}
      }
      return item
    })
    setdataProcedimientos(cambiarOrden)
    //console.log(cambiarOrden,'DEBOTENER')
    //console.log(cambiarOrden,'ordennn')
    //console.log(procedimientosSinOrden,'procedimientosSinOrden despues')

    const validarOr = cambiarOrden.some((item)=>(item.tipoHojaFact === 'seleccionar') || (item.via === 'seleccionar') || (item.especilidadCirujano === 'seleccionar') || (item.opcion === 'seleccionar')) 
    if(validarOr){
      setvalidarButtonDescargaPDF(true)
    }else{
      setvalidarButtonDescargaPDF(false)
    }
   
    //validar si todos los procedimientos tiene la tipoHojaFact con un valor 'F' o 'H', que no este en "seleccionar"
    const validarOrden = cambiarOrden.every((validar)=>(validar.tipoHojaFact !== 'seleccionar') && (validar.via !== 'seleccionar'))
    if(validarOrden){

    const procedimientosConOrden = cambiarOrden.reduce((contador, procedimiento) => {
      if (procedimiento.orden !== undefined) {
        return contador + 1;
      }
      return contador;
    }, 0);

    //con orden
    const procedimientosSinOrden = cambiarOrden.reduce((contador, procedimiento) => {
      if (procedimiento.orden === undefined) {
        return contador + 1;
      }
      return contador;
    }, 0);

    // console.log(procedimientosConOrden,'procedimientosConOrden numero')
    // console.log(dataProcedimientos.length,'longitud')
    //validamos que el array de procedimientos si esta completa la columna orden, si esta consultamos el endpoint para actualizar los precios
    if(procedimientosConOrden === dataProcedimientos.length){
      setloadingProcedimientosPrecios(false)
      setvalidarButtonDescargaPDF(false)
      //console.log('consultar api precios')
      let volverAConsultarOrden = cambiarOrden.map((procedimiento)=>{
        return{
          codigoFormaLiquidacion:procedimiento.ForLiqCod, 
          codPortafolioProc:variablePTCODI, 
          codProcedimiento:procedimiento.CrgCod, 
          numContrato:item.ProEPS, 
          ViaProgQX:procedimiento.via, 
          EspCirProgQX: procedimiento.especilidadCirujano, 
          OpcionProgQX:procedimiento.opcion, 
          NumeroOrden: procedimiento.orden,
          TipoTransaccion:procedimiento.tipoHojaFact,
          CodEmpresa:usuarioInfo.Empresa,
          CodSede:usuarioInfo.Sede,
          CodigoCirugia:item.ProCirCod,
          TipoProcQX:procedimiento.agrupadorProcedimiento
        }})
        //console.log(volverAConsultarOrden,'volverAConsultarOrden TTTTT')
        const arrayOrganizadoOrden = {
          "arrayProcedimientos": volverAConsultarOrden
        };
        postPreciosProcedimientosLiquidacionQx(arrayOrganizadoOrden).then((orden)=>{
          //console.log(orden.data.flat(),'CAMBIOSSSFF')
          let arraySecundarioPrecios = orden.data.flat()
          //cambiar los datos al array de los precios para mostrar en el PDF
          const arrayPrincipalModificado = dataPreciosPDF.map(objPrincipal => {
            objPrincipal.precios = objPrincipal.precios.map(precio => {
              arraySecundarioPrecios.forEach(objSecundario => {
                if ((parseInt(precio.CodigoProcedimiento) === parseInt(objSecundario.CodigoProcedimiento)) && (precio.DescripcionHonorario === objSecundario.DescripcionHonorario)) {
                  precio.ValorHonorarioImprLiqCir = objSecundario.ValorHonorarioImprLiqCir;
                  precio.ValorHonorario = objSecundario.ValorHonorario;
                  precio.NumeroOrden = objSecundario.NumeroOrden;
                  precio.PorcOrden = objSecundario.PorcOrden;
                  precio.ValordeHonorarios= objSecundario.ValordeHonorarios;
                  precio.PorcTarifaBase = objSecundario.PorcTarifaBase;
                }
              });
              return precio;
            });
            return objPrincipal;
          });

          const volverACalcularPrecioProcedimiento = arrayPrincipalModificado.map(item => {
            const totalFacturable = item.precios
              .filter(precio => precio.tipoHojaFact === 'F')
              .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
        
            return {...item, precioProcedimiento: totalFacturable};
          });

          //colocar en la variable orden el numeroOrden
          const arrayModificado = volverACalcularPrecioProcedimiento.map(item => {
            // suponiendo que solo hay un objeto en la matriz de precios
            const { NumeroOrden } = item.precios[0];
            return {...item, orden: NumeroOrden};
          });         
          
          //organizar de mayor a menor el 'orden'
          ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR ORDEN////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvFacturable
          let indvFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //bilaFacturable
          let bilaFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvHojaGasto
          let indvHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //bilaHojaGasto
          let bilaHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         

          let unionArray = [...multFacturableOrden, ...indvFacturableOrden, ...bilaFacturableOrden, ...multHojaGastoOrden, ...indvHojaGastoOrden, ...bilaHojaGastoOrden]
          ///console.log(unionArray,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////
          setdataPreciosPDF(unionArray)
          console.log(unionArray,'arrayModificadoarrayModificadoORDEN')
          setTimeout(() => {          
            setloadingProcedimientosPrecios(true)
          }, 1000);          
          
          //console.log(arrayModificado,'NUEVOARRAYOBJETOSS')

          //calcular el total de todos los precios procedimientos qx
          let totalPreciosProcedimientos = arrayModificado.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
          settotalPrecioProcedimiento(totalPreciosProcedimientos)
          console.log(totalPreciosProcedimientos,'TOTAL')
        })
    }

    // if(procedimientosConOrden !== 0 && procedimientosConOrden !== dataProcedimientos.length){
    //   //console.log('debe de completar la orden')
    //   setvalidarButtonDescargaPDF(true)
    // }
    

    // if(procedimientosConOrden === 0){
    //   //console.log('No se consulta api')
    // }

    //
    // const procedimientosSinOrden = cambiarOrden.reduce((contador, procedimiento) => {
    //   if (procedimiento.orden === undefined) {
    //     return contador + 1;
    //   }
    //   return contador;
    // }, 0);

    ///validar si la cantidad orden es igual a la longitud a los procedimientos
    else if(procedimientosSinOrden === dataProcedimientos.length){
      console.log('ENTROOO')
      setvalidarButtonDescargaPDF(false)
      //aparece un spiner para actualizar los precios
      setloadingProcedimientosPrecios(false)
      //organizar el array de mayor a menor
      //cambiarOrden.sort((a, b) => b.CantidadUVR - a.CantidadUVR);
      
      //asignarle el orden del mayor a menor,
      // cambiarOrden = cambiarOrden.map((obj, index) => {
      //   return { ...obj, orden: index + 1 };
      // });
      ////////////////////////////////////////////////
      //FACTURABLE
      //multFacturable filtrar
      let multFacturable = cambiarOrden.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
      multFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
      multFacturable = multFacturable.map((obj, index) => {
        return { ...obj, orden: index + 1 };
      });
      //indvFacturable
      let indvFacturable = cambiarOrden.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
      indvFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
      indvFacturable = indvFacturable.map((obj) => {
        return { ...obj, orden: 1 };
      });

      //bilaFacturable
      let bilaFacturable = cambiarOrden.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
      bilaFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
      bilaFacturable = bilaFacturable.map((obj, index) => {
        return { ...obj, orden: index + 1 };
      });

      //HOJA DE GASTO
      //multHojaGasto
      let multHojaGasto = cambiarOrden.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
      multHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
      multHojaGasto = multHojaGasto.map((obj, index) => {
        return { ...obj, orden: index + 1 };
      });
      //indvHojaGasto
      let indvHojaGasto = cambiarOrden.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
      indvHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
      indvHojaGasto = indvHojaGasto.map((obj) => {
        return { ...obj, orden: 1 };
      });
      //bilaHojaGasto
      let bilaHojaGasto = cambiarOrden.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
      bilaHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
      bilaHojaGasto = bilaHojaGasto.map((obj, index) => {
        return { ...obj, orden: index + 1 };
      });
      let unionFacturableHojaGasto = [...multFacturable, ...indvFacturable, ...bilaFacturable, ...multHojaGasto, ...indvHojaGasto, ...bilaHojaGasto]
      console.log(unionFacturableHojaGasto,'unionFacturableHojaGastoHHHHHHHHHHHHH')
      setdataPreciosPDF(unionFacturableHojaGasto)
      ///////////////////////////////////////////////////////////

      //console.log(cambiarOrden,'SIN ORDEN SE ORGANIZO')
      const volverAConsultarPrecios = unionFacturableHojaGasto.map((procedimiento)=>{
        return {
          codigoFormaLiquidacion:procedimiento.ForLiqCod, 
          codPortafolioProc:variablePTCODI, 
          codProcedimiento:procedimiento.CrgCod, 
          numContrato:item.ProEPS, 
          ViaProgQX:procedimiento.via, 
          EspCirProgQX: procedimiento.especilidadCirujano, 
          OpcionProgQX:procedimiento.opcion,
          NumeroOrden:`${procedimiento.orden}`,
          TipoTransaccion:procedimiento.tipoHojaFact,
          CodEmpresa:usuarioInfo.Empresa,
          CodSede:usuarioInfo.Sede,
          CodigoCirugia:item.ProCirCod,
          TipoProcQX:procedimiento.agrupadorProcedimiento
        }
      })
      const arrayRecibido = {
        "arrayProcedimientos": volverAConsultarPrecios
      };
      //consultar de nuevo el endpoint para los nuevos precios
      postPreciosProcedimientosLiquidacionQx(arrayRecibido).then((orden)=>{
        console.log('CAMBIOSSSFF')
          let arraySecundarioPrecios = orden.data.flat()
          //cambiar los datos al array de los precios para mostrar en el PDF
          const arrayPrincipalModificado = dataPreciosPDF.map(objPrincipal => {
            objPrincipal.precios = objPrincipal.precios.map(precio => {
              arraySecundarioPrecios.forEach(objSecundario => {
                if ((parseInt(precio.CodigoProcedimiento) === parseInt(objSecundario.CodigoProcedimiento)) && (precio.DescripcionHonorario === objSecundario.DescripcionHonorario)) {
                  precio.ValorHonorarioImprLiqCir = objSecundario.ValorHonorarioImprLiqCir;
                  precio.ValorHonorario = objSecundario.ValorHonorario;
                  precio.NumeroOrden = objSecundario.NumeroOrden;
                  precio.PorcOrden = objSecundario.PorcOrden;
                  precio.ValordeHonorarios= objSecundario.ValordeHonorarios;
                  precio.PorcTarifaBase = objSecundario.PorcTarifaBase;
                }
              });
              return precio;
            });
            return objPrincipal;
          });
          //volver a calcular los precios de los procedimientos
          const volverACalcularPrecioProcedimiento = arrayPrincipalModificado.map(item => {
            const totalFacturable = item.precios
              .filter(precio => precio.tipoHojaFact === 'F')
              .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
        
            return {...item, precioProcedimiento: totalFacturable};
          });

          //asignarle el orden que esta en la array de precios
          const arrayModificado = volverACalcularPrecioProcedimiento.map(item => {            
            const { NumeroOrden } = item.precios[0];
            return {...item, orden: NumeroOrden};
          });

          ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR ORDEN////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvFacturable
          let indvFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //bilaFacturable
          let bilaFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvHojaGasto
          let indvHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //bilaHojaGasto
          let bilaHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         

          let unionArray = [...multFacturableOrden, ...indvFacturableOrden, ...bilaFacturableOrden, ...multHojaGastoOrden, ...indvHojaGastoOrden, ...bilaHojaGastoOrden]
          ///console.log(unionArray,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////
          
          setdataPreciosPDF(unionArray)   
          console.log(unionArray,'arrayModificadoarrayModificadoORDEN')
          setTimeout(() => {          
            setloadingProcedimientosPrecios(true)
          }, 1000); 

          //calcular el total de todos los precios procedimientos qx
          let totalPreciosProcedimientos = arrayModificado.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
          console.log(totalPreciosProcedimientos,'TOTAL')
          settotalPrecioProcedimiento(totalPreciosProcedimientos)
      })
    }else{
      setvalidarButtonDescargaPDF(true)
    }
  }

  }

  ////input medico
  const handleonClickMedico=(honorario)=>{
    //console.log(honorario.CirujanoSoN,'honorario')
    const validarParticipo = honorario.CirujanoSoN
    if(validarParticipo === 'N'){
      //console.log('Entro')
      setmodalOnValidarParticipo(true)
    }else{
      setSelectedRowHonorario(honorario)
      setmodalOnMedico(true)
    }
    
  }

  //pasar la data medico
  const passDataMedico =(data)=>{
    console.log(data,'FFF')
    console.log(selectedRowHonorario,'FFF2')
    //validar
    // const validar = dataPreciosTabla.find((item)=>((item.DescripcionHonorario === selectedRowHonorario.DescripcionHonorario) && (parseInt(item.CodigoProcedimiento) === parseInt(selectedRowHonorario.CodigoProcedimiento))))
    // console.log(validar.CirujanoSoN,'validar')
    const nuevoMedico = dataPreciosTabla.map((item)=>{
      if((item.DescripcionHonorario === selectedRowHonorario.DescripcionHonorario) && (parseInt(item.CodigoProcedimiento) === parseInt(selectedRowHonorario.CodigoProcedimiento))){
        return {...item, CodigoMedico: data.codigoMedicoEs, NombreMedico: data.nombreMedicoEs, CodigoEspecialidad: data.codigoEspecialidad, NombreEspecialidad: data.nombreEspecialidad}
      }
      return item
    })
    setdataPreciosTabla(nuevoMedico)

    //guardar anestesiologo 
    if(selectedRowHonorario.DescripcionHonorario === "ANESTESIOLOGO"){
      setdataAnestesiologo({
        nombreMedicoEs: data.nombreMedicoEs,
        codigoMedicoEs: data.codigoMedicoEs
      })
    }

    //agregar el medico a dataPreciosPDF
    const agregarMedico = dataPreciosPDF.map((objPrincipal)=>{
      objPrincipal.precios = objPrincipal.precios.map((objSecundario)=>{
        if((objSecundario.DescripcionHonorario === selectedRowHonorario.DescripcionHonorario) && (parseInt(objSecundario.CodigoProcedimiento) === parseInt(selectedRowHonorario.CodigoProcedimiento))){
          return {
            ...objSecundario,
            CodigoMedico: data.codigoMedicoEs,
            NombreMedico: data.nombreMedicoEs,
            NombreEspecialidad: data.nombreEspecialidad,
            CodigoEspecialidad: data.codigoEspecialidad,
        }
        }else{
          return objSecundario;
        }
      })
      return objPrincipal;
    })
    setdataPreciosPDF(agregarMedico)
  }

  //participo
  const onCheckboxChangeParticipo=(index, isChecked,item)=>{
    console.log(index,'index')
    console.log(isChecked,'e')
    console.log(dataPreciosTabla,'dataPreciosTabla')
    console.log(dataPreciosPDF,'dataPreciosPDF')
    console.log(item,'item onCheckboxChangeParticipo')
    const newData = [...dataPreciosTabla];
    if (isChecked) {
      newData[index].CirujanoSoN = 'S';
      //medico
      setSelectedRowHonorario(item)
      setmodalOnMedico(true)
    } else {
      //quitarle el nombre de medico, codigo de medico, especilidad, codigo especialidad a dataPreciosTabla
      newData[index].CirujanoSoN = 'N';
      newData[index].CodigoMedico = '';
      newData[index].NombreMedico = '';
      newData[index].NombreEspecialidad = '';
      newData[index].CodigoEspecialidad = '';
      
      //quitarle el nombre de medico, codigo de medico, especilidad, codigo especialidad a dataPreciosPDF
      console.log(dataPreciosPDF,'Antes dataPreciosPDF')
      const quitarCodigoMedico = dataPreciosPDF.map((objPrincipal) => {
        objPrincipal.precios = objPrincipal.precios.map((objSecundario) => {
            if ((item.DescripcionHonorario === objSecundario.DescripcionHonorario) && (item.CodigoProcedimiento === objSecundario.CodigoProcedimiento)) {
                return {
                    ...objSecundario,
                    CodigoMedico: '',
                    NombreMedico: '',
                    NombreEspecialidad: '',
                    CodigoEspecialidad: '',
                }
            } else {
                return objSecundario;
            }
        });
        return objPrincipal;
    });
    setdataPreciosPDF(quitarCodigoMedico)
      console.log(quitarCodigoMedico,'despues dataPreciosPDF')
    }
    setdataPreciosTabla(newData);
  }

  //agrupador qx
  const handleSelectAgrupadorQX =(id,value)=>{
    //console.log(id,'handleSelectAgrupadorQXid')
    //console.log(value,'handleSelectAgrupadorQXvalue')
    //console.log(dataProcedimientos,'dataProcedimientos')
    //setagrupadorMULTBILAINDV(value)
    //agrupador cambio PDF
    const cambioAgrupador =  dataPreciosPDF.map((item)=>{      
      if(parseInt(item.CrgCod) === parseInt(id)){
        console.log('ENTRO AGRUPADOR')
        return {...item, agrupadorProcedimiento:value}
      }
      return item
    })
    console.log(cambioAgrupador,'AGREPADORRRR')
    setdataPreciosPDF(cambioAgrupador)

    //agrupador cambio procedimientos
    const cambioAgrupadorProcedimiento = dataProcedimientos.map((item)=>{
      if(parseInt(item.CrgCod) === parseInt(id)){
        return {...item, agrupadorProcedimiento:value}
      }
      return item
    })
    setdataProcedimientos(cambioAgrupadorProcedimiento)

    const validarAgrupador = cambioAgrupador.some((item)=>(item.tipoHojaFact === 'seleccionar') || (item.via === 'seleccionar') || (item.especilidadCirujano === 'seleccionar') || (item.opcion === 'seleccionar')) 
    if(validarAgrupador){
      setvalidarButtonDescargaPDF(true)
    }else{
      setvalidarButtonDescargaPDF(false)
    }

    //validar si todos los procedimientos tiene la tipoHojaFact con un valor 'F' o 'H', que no este en "seleccionar"
    const validarTipoHojaFactVia = cambioAgrupador.every((validar)=>(validar.tipoHojaFact !== 'seleccionar') && (validar.via !== 'seleccionar'))

    if(validarTipoHojaFactVia){
      console.log('ENTRO factura')
      ///contar la cantidad undefined que tiene la orden
      const procedimientosSinOrden = cambioAgrupadorProcedimiento.reduce((contador, procedimiento) => {
        if (procedimiento.orden === undefined) {
          return contador + 1;
        }
        return contador;
      }, 0);
      //con orden
      const procedimientosConOrden = cambioAgrupadorProcedimiento.reduce((contador, procedimiento) => {
        if (procedimiento.orden !== undefined) {
          return contador + 1;
        }
        return contador;
      }, 0);
      if(procedimientosSinOrden === dataProcedimientos.length){
        setvalidarButtonDescargaPDF(false)
      //FACTURABLE
      //multFacturable filtrar
      let multFacturable = cambioAgrupador.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
      multFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
      multFacturable = multFacturable.map((obj, index) => {
        return { ...obj, orden: index + 1 };
      });
      //indvFacturable
      let indvFacturable = cambioAgrupador.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
      indvFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
      indvFacturable = indvFacturable.map((obj) => {
        return { ...obj, orden: 1 };
      });

      //bilaFacturable
      let bilaFacturable = cambioAgrupador.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
      bilaFacturable.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
      bilaFacturable = bilaFacturable.map((obj, index) => {
        return { ...obj, orden: index + 1 };
      });

      //HOJA DE GASTO
      //multHojaGasto
      let multHojaGasto = cambioAgrupador.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
      multHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
      multHojaGasto = multHojaGasto.map((obj, index) => {
        return { ...obj, orden: index + 1 };
      });
      //indvHojaGasto
      let indvHojaGasto = cambioAgrupador.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
      indvHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
      indvHojaGasto = indvHojaGasto.map((obj) => {
        return { ...obj, orden: 1 };
      });
      //bilaHojaGasto
      let bilaHojaGasto = cambioAgrupador.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
      bilaHojaGasto.sort((a, b) => parseInt(b.CantidadUVR) - parseInt(a.CantidadUVR));
      bilaHojaGasto = bilaHojaGasto.map((obj, index) => {
        return { ...obj, orden: index + 1 };
      });

      let unionFacturableHojaGasto = [...multFacturable, ...indvFacturable, ...bilaFacturable, ...multHojaGasto, ...indvHojaGasto, ...bilaHojaGasto]
      console.log(unionFacturableHojaGasto,'unionFacturableHojaGastoHHHHHHHHHHHHH')
      setdataPreciosPDF(unionFacturableHojaGasto)

      //validar si todas las vias es dierente a "seleccionar"
      //let validarVIA = unionFacturableHojaGasto.every((validar)=> validar.via !== 'seleccionar')
      //if(validarVIA){
        //console.log('ENTRTO VIA')
         
      
        //volver a consultar los precios
        const volverAConsultarPrecios =unionFacturableHojaGasto.map((procedimiento)=>{
          return {
            codigoFormaLiquidacion:procedimiento.ForLiqCod, 
            codPortafolioProc:variablePTCODI, 
            codProcedimiento:procedimiento.CrgCod, 
            numContrato:item.ProEPS, 
            ViaProgQX:procedimiento.via, 
            EspCirProgQX: procedimiento.especilidadCirujano, 
            OpcionProgQX:procedimiento.opcion,
            NumeroOrden:`${procedimiento.orden}`,
            TipoTransaccion:procedimiento.tipoHojaFact,
            CodEmpresa:usuarioInfo.Empresa,
            CodSede:usuarioInfo.Sede,
            CodigoCirugia:item.ProCirCod,
            TipoProcQX:procedimiento.agrupadorProcedimiento
          }
        })
        const arrayOrganizadoOrden = {
          "arrayProcedimientos": volverAConsultarPrecios
        };
        setloadingProcedimientosPrecios(false)
        postPreciosProcedimientosLiquidacionQx(arrayOrganizadoOrden).then((ordenProcedimiento)=>{
          console.log(ordenProcedimiento,'AGRUPADORRR')
          let arraySecundarioPrecios = ordenProcedimiento.data.flat()
          //cambiar los datos al array de los precios para mostrar en el PDF
          const arrayPrincipalModificado = unionFacturableHojaGasto.map(objPrincipal => {
            objPrincipal.precios = objPrincipal.precios.map(precio => {
              arraySecundarioPrecios.forEach(objSecundario => {
                if ((parseInt(precio.CodigoProcedimiento) === parseInt(objSecundario.CodigoProcedimiento)) && (precio.DescripcionHonorario === objSecundario.DescripcionHonorario)) {
                  precio.ValorHonorarioImprLiqCir = objSecundario.ValorHonorarioImprLiqCir;
                  precio.ValorHonorario = objSecundario.ValorHonorario;
                  precio.NumeroOrden = objSecundario.NumeroOrden;
                  precio.PorcOrden = objSecundario.PorcOrden;
                  precio.ValordeHonorarios= objSecundario.ValordeHonorarios;
                  precio.PorcTarifaBase = objSecundario.PorcTarifaBase;
                }
              });
              return precio;
            });
            return objPrincipal;
          });
          //volver a calcular los precios de los procedimientos
          const volverACalcularPrecioProcedimiento = arrayPrincipalModificado.map(item => {
            const totalFacturable = item.precios
              .filter(precio => precio.tipoHojaFact === 'F')
              .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
        
            return {...item, precioProcedimiento: totalFacturable};
          });
          //asignarle el orden que esta en la array de precios
          const arrayModificado = volverACalcularPrecioProcedimiento.map(item => {            
            const { NumeroOrden } = item.precios[0];
            return {...item, orden: NumeroOrden};
          });
          //arrayModificado.sort((a, b) => parseInt(b.orden) - parseInt(a.orden));
          ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR ORDEN////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvFacturable
          let indvFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //bilaFacturable
          let bilaFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvHojaGasto
          let indvHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //bilaHojaGasto
          let bilaHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         

          let unionArray = [...multFacturableOrden, ...indvFacturableOrden, ...bilaFacturableOrden, ...multHojaGastoOrden, ...indvHojaGastoOrden, ...bilaHojaGastoOrden]
          ///console.log(unionArray,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////
          setdataPreciosPDF(unionArray)  
          console.log(unionArray,'arrayModificadoarrayModificadoAgrupadorORDENNNNN')
          
          let totalPreciosProcedimientos = arrayModificado.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
          settotalPrecioProcedimiento(totalPreciosProcedimientos)
          console.log(totalPreciosProcedimientos,'TOTAL')
          setTimeout(() => {          
            setloadingProcedimientosPrecios(true)
          }, 1000);  
        })
      }

       ////////////////////////////////////////CON ORDEN////////////////////////
      //  const procedimientosConOrden = cambioAgrupadorProcedimiento.reduce((contador, procedimiento) => {
      //   if (procedimiento.orden !== undefined) {
      //     return contador + 1;
      //   }
      //   return contador;
      // }, 0);
      //validamos que el array de procedimientos si esta completa la columna orden, si esta consultamos el endpoint para actualizar los precios
      else if(procedimientosConOrden === dataProcedimientos.length){
        setloadingProcedimientosPrecios(false)
        setvalidarButtonDescargaPDF(false)
        let volverAConsultarOrden = cambioAgrupador.map((procedimiento)=>{
          return{
            codigoFormaLiquidacion:procedimiento.ForLiqCod, 
            codPortafolioProc:variablePTCODI, 
            codProcedimiento:procedimiento.CrgCod, 
            numContrato:item.ProEPS, 
            ViaProgQX:procedimiento.via, 
            EspCirProgQX: procedimiento.especilidadCirujano, 
            OpcionProgQX:procedimiento.opcion, 
            NumeroOrden: procedimiento.orden,
            TipoTransaccion:procedimiento.tipoHojaFact,
            CodEmpresa:usuarioInfo.Empresa,
            CodSede:usuarioInfo.Sede,
            CodigoCirugia:item.ProCirCod,
            TipoProcQX:procedimiento.agrupadorProcedimiento
          }})
          const arrayOrganizadoOrden = {
            "arrayProcedimientos": volverAConsultarOrden
          };
          postPreciosProcedimientosLiquidacionQx(arrayOrganizadoOrden).then((orden)=>{
            let arraySecundarioPrecios = orden.data.flat()
            //cambiar los datos al array de los precios para mostrar en el PDF
            const arrayPrincipalModificado = cambioAgrupador.map(objPrincipal => {
              objPrincipal.precios = objPrincipal.precios.map(precio => {
                arraySecundarioPrecios.forEach(objSecundario => {
                  if ((parseInt(precio.CodigoProcedimiento) === parseInt(objSecundario.CodigoProcedimiento)) && (precio.DescripcionHonorario === objSecundario.DescripcionHonorario)) {
                    precio.ValorHonorarioImprLiqCir = objSecundario.ValorHonorarioImprLiqCir;
                    precio.ValorHonorario = objSecundario.ValorHonorario;
                    precio.NumeroOrden = objSecundario.NumeroOrden;
                    precio.PorcOrden = objSecundario.PorcOrden;
                    precio.ValordeHonorarios= objSecundario.ValordeHonorarios;
                    precio.PorcTarifaBase = objSecundario.PorcTarifaBase;
                  }
                });
                return precio;
              });
              return objPrincipal;
            });
            const volverACalcularPrecioProcedimiento = arrayPrincipalModificado.map(item => {
              const totalFacturable = item.precios
                .filter(precio => precio.tipoHojaFact === 'F')
                .reduce((suma, precio) => suma + precio.ValorHonorarioImprLiqCir, 0);
          
              return {...item, precioProcedimiento: totalFacturable};
            });
            //colocar en la variable orden el numeroOrden
            const arrayModificado = volverACalcularPrecioProcedimiento.map(item => {
              // suponiendo que solo hay un objeto en la matriz de precios
              const { NumeroOrden } = item.precios[0];
              return {...item, orden: NumeroOrden};
            });
            //organizar de mayor a menor el 'orden'
            ///////////////////////////ORDENAR ORDEN DE MAYOR A MENOR ORDEN////////////////
          //FACTURABLE
          //multFacturable filtrar
          let multFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'F');
          multFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvFacturable
          let indvFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'F');
          indvFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //bilaFacturable
          let bilaFacturableOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'F');
          bilaFacturableOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //HOJA DE GASTO
          //multHojaGasto
          let multHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'MULT' && obj.tipoHojaFact === 'H');
          multHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
          
          //indvHojaGasto
          let indvHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'INDV' && obj.tipoHojaFact === 'H');
          indvHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         
          //bilaHojaGasto
          let bilaHojaGastoOrden = arrayModificado.filter(obj => obj.agrupadorProcedimiento === 'BILA' && obj.tipoHojaFact === 'H');
          bilaHojaGastoOrden.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         

          let unionArray = [...multFacturableOrden, ...indvFacturableOrden, ...bilaFacturableOrden, ...multHojaGastoOrden, ...indvHojaGastoOrden, ...bilaHojaGastoOrden]
          ///console.log(unionArray,'unionFacturableHojaGastoHHHHHHHHHHHHH')
        //////////////////////////FIN/////////////////////////////////////////////////////////////////////
            setdataPreciosPDF(unionArray)  
            console.log(unionArray,'arrayModificadoarrayModificadoAgrupadorORDENNNNNNNNN')
            //calcular el total de todos los precios procedimientos qx
            let totalPreciosProcedimientos = arrayModificado.reduce((sum, procedimiento) => sum + procedimiento.precioProcedimiento, 0);
            settotalPrecioProcedimiento(totalPreciosProcedimientos)
            console.log(totalPreciosProcedimientos,'TOTAL')
            setTimeout(() => {          
              setloadingProcedimientosPrecios(true)
          }, 1000);  
          })

      }else{
        setvalidarButtonDescargaPDF(true)
      }


    } 
    
  }

  //colocar puntos a los precios ejemplo 1.000.000
  const formatearNumeroConPuntos=(numero)=> {
    if (numero === undefined || numero === null) {
      //console.error('Número no definido:', numero);
      return "0";  // o cualquier valor por defecto que desees
  }
    return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

  
  //console.log(dataPreciosPDF,'CONSOLEE dataPreciosPDF')
  //console.log(dataProcedimientos,'CONSOLE dataProcedimientos')

  //PAQUETE FUNCIONES
  const handleOnChangeFacturableHojaGastoPaquete=(id,value, precioProcedimiento) => {
      let cambiosSelectTipo = dataProcedimientosPaquete.map((item)=>{
        if(item.CodigoProcedimiento === id){
          if(value === 'H'){
            //realizar una resta al precio total de los procedimientos            
            const precioTotalProcedimiento = parseInt(valorTotalProcedimientos) - parseInt(precioProcedimiento)
            setValorTotalProcedimientos(precioTotalProcedimiento)
          }else if(value === 'F'){
            //realizar una suma al precio total de los procedimientos 
            const precioTotalProcedimiento = parseInt(valorTotalProcedimientos) + parseInt(precioProcedimiento)
            setValorTotalProcedimientos(precioTotalProcedimiento)
          }
          //si el valor es diferente a H o F no se hace nada
          return {...item, tipoHojaFact:value }
        }
        return item
      })
      setDataProcedimientosPaquete(cambiosSelectTipo)
      console.log(cambiosSelectTipo, ' cambiosSelectTipo')
    }

    const handleSelectAgrupadorQXPaquete=(id,value) => {
      let cambiosSelectAgrupador = dataProcedimientosPaquete.map((item)=>{
        if(item.CodigoProcedimiento === id){
          return {...item, agrupadorProcedimiento:value }
        }
        return item
      })
      setDataProcedimientosPaquete(cambiosSelectAgrupador)
      console.log(cambiosSelectAgrupador, ' cambiosSelectAgrupador')
    }

    const handleSelectChangeViaPaquete=(id,value) => {
      let cambiosSelectVia = dataProcedimientosPaquete.map((item)=>{
        if(item.CodigoProcedimiento === id){
          return {...item, via:value }
        }
        return item
      })
      setDataProcedimientosPaquete(cambiosSelectVia)
      console.log(cambiosSelectVia, ' cambiosSelectVia')
    }

    const handleSelectChangeEspecialidadCirujanoPaquete=(id,value) => {
      let cambiosSelectEspecialidadCirujano = dataProcedimientosPaquete.map((item)=>{
        if(item.CodigoProcedimiento === id){
          return {...item, especilidadCirujano:value }
        }
        return item
      })
      setDataProcedimientosPaquete(cambiosSelectEspecialidadCirujano)
      console.log(cambiosSelectEspecialidadCirujano, ' cambiosSelectEspecialidadCirujano')
    }

    const handleSelectChangeOpcionPaquete=(id,value) => {
      let cambiosSelectOpcion = dataProcedimientosPaquete.map((item)=>{
        if(item.CodigoProcedimiento === id){
          return {...item, opcion:value }
        }
        return item
      })
      setDataProcedimientosPaquete(cambiosSelectOpcion)
      console.log(cambiosSelectOpcion, ' cambiosSelectOpcion')
    }

    const valorPocentajeProcedimiento=(id, precio ,porcentaje)=>{      
      // calcular el precio con el porcentaje
      let precioProcedimientoConPorcentaje = dataProcedimientosPaquete.map((item)=>{
        if(item.CodigoProcedimiento === id){
          return {...item, precioPorcentajeProcedimiento:(parseInt(precio) * parseInt(porcentaje)) / 100, porcentaje:porcentaje}
        }
        return item
      })      
      setDataProcedimientosPaquete(precioProcedimientoConPorcentaje)

      //precio total de los procedimientos solo los que son facturables
      const totalPrecioProcedimiento = precioProcedimientoConPorcentaje.reduce((acc, item) => {
        if(item.tipoHojaFact === 'F') {
          return acc + parseInt(item.precioPorcentajeProcedimiento)
        }
        return 0;
      }, 0);
      setValorTotalProcedimientos(totalPrecioProcedimiento)
      console.log(totalPrecioProcedimiento, ' totalPrecioProcedimiento')
    }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)]   mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md  bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Liquidación de los procedimiento Cirugía
            </h5>
            <button
              type="button"
              onClick={handleCancelClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          
            <div className="flex-auto overflow-y-auto relative p-1">
             { 
               loadingProcedimientosPrecios?
              <div className="flex-auto overflow-y-auto relative p-1">
          
              
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Tipo Documento
                    </label>
                    <input
                      defaultValue={item.MPTDoc}
                      //value={seleccionarMedico.MedCod}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Número Documento
                    </label>
                    <input
                      disabled={true}
                      defaultValue={item.MPCedu}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Número Documento
                    </label>
                    <input
                      disabled={true}
                      defaultValue={item.MPNOMC}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  
                </div>
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Codigo
                    </label>
                    <input
                      defaultValue={item.ProCirCod}
                      //value={seleccionarMedico.MedCod}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Contrato
                    </label>
                    <input
                      disabled={true}
                      defaultValue={nombreIdContrato}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Fecha
                    </label>
                    <input
                      disabled={true}
                      defaultValue={item.ProFec?item.ProFec.split(' ')[0]:null}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  
                </div>
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Dx Principal
                    </label>
                    <input
                      //defaultValue={dxPrincipal.DMCodi}
                      //value={seleccionarMedico.MedCod}
                      defaultValue={item.DiaSal}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-2/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium pt-5">
                      
                    </label>
                    <input
                      disabled={true}
                      //defaultValue={item.ProEPS}
                      // value={seleccionarMedico.MMNomM}
                      //defaultValue={dxPrincipal.DMNomb}
                      defaultValue={item.DMNomb}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Dx Complicación
                    </label>
                    <input
                      defaultValue={complicacionesDx.DxCompl}
                      //value={seleccionarMedico.MedCod}
                      //defaultChecked={dxComplicaciones.DMCodi}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-2/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium pt-5">
                      
                    </label>
                    <input
                      disabled={true}
                      //defaultChecked={dxComplicaciones.DMNomb}
                      defaultValue={complicacionesDx.DMNomb}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="flex flex-row py-1  text-left">
                 
                  
                </div>
              
            
            
            <div className="text-center bg-[#05a29d] pb-1">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mt-1 text-white font-medium px-1 text-xl "
              >
                Procedimientos quirúrgicos tipo paquete
              </label>
            </div>

            <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto ">
                  <div className="py-1 inline-block min-w-full ">
                    <div className="overflow-hidden">
                      <table className="min-w-full text-center bg-gray-200">
                        <thead className="">
                          <tr>
                          <th
                              scope="col"
                              className="text-sm font-medium text-gray-900"
                            >                              
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Codigo Qx
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Descripción
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Tipo
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900"
                            >
                              Agrupador
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Via
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Esp.Ciru
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Opción
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Porcentaje
                            </th>                                 
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Valor
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Descripcion Tarifario
                            </th>
                          </tr>
                        </thead>

                        {
                          
                          dataProcedimientosPaquete.map((item)=>(
                            <tbody>
                              <tr className="divide-y divide-slate-700">
                                <td></td>
                              
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                 
                                  {item.CodigoProcedimiento}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                  
                                  {item.NombreProcedimiento}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                  <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                      <select                                        
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        value={item.tipoHojaFact}                                        
                                        onChange={(e) => handleOnChangeFacturableHojaGastoPaquete(item.CodigoProcedimiento, e.target.value, item.precioPorcentajeProcedimiento)}
                                      >
                                        
                                        <option value="F">Facturable</option>
                                        <option value="H">Hoja de Gasto</option>
                                      </select>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                <select
                                        
                                        className="form-select block w-auto px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        //value={item.tipoHojaFact}
                                        value={item.agrupadorProcedimiento}
                                        onChange={(e) => handleSelectAgrupadorQXPaquete(item.CodigoProcedimiento, e.target.value)}
                                      >
                                        
                                        <option value="BILA">Bilateral</option>
                                        <option value="INDV">Individual</option>
                                        <option value="MULT">Multiple</option>
                                      </select>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                  <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                      <select
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        value={item.via}
                                        onChange={(e)=>handleSelectChangeViaPaquete(item.CodigoProcedimiento, e.target.value)}
                                      >
                                        
                                        <option value="1">Unica via</option>
                                        <option value="2">Diferente via</option>
                                        <option value="3">Bilateral</option>
                                      </select>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                  <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                      <select
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        value={item.especilidadCirujano}
                                        onChange={(e)=>handleSelectChangeEspecialidadCirujanoPaquete(item.CodigoProcedimiento, e.target.value)}
                                      >
                                        
                                        <option value="1">Igual Especialidad</option>
                                        <option value="2">Diferente Especialidad</option>
                                      </select>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-8  whitespace-pre-wrap">
                                  <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                      <select
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        value={item.opcion}
                                        onChange={(e)=>handleSelectChangeOpcionPaquete(item.CodigoProcedimiento, e.target.value)}
                                      >
                                        {
                                          dataOpcionCirugia.map((item)=>(
                                            <option value={item.PrcMulOpc} key={item.PrcMulOpc}>{item.PrcMulDsc}</option>
                                          ))
                                        }
                                      </select>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 whitespace-pre-wrap">
                                  <div className="pt-2">
                                    <div className="mb-3 w-full">
                                      <input
                                        defaultValue={item.porcentaje}
                                        onChange={(e) => {
                                          const value = parseInt(e.target.value, 10);

                                          // Validar que esté dentro del rango
                                          if (value >= 1 && value <= 100) {
                                            valorPocentajeProcedimiento(
                                              item.CodigoProcedimiento,
                                              parseInt(item.ValorBaseTarifa) === 0
                                                ? item.ValorUnitario
                                                : item.ValorBaseTarifa,
                                              value
                                            );
                                          } else {
                                            // Si no está en el rango, lo vaciamos o lo limitamos
                                            e.target.value = "";
                                          }
                                        }}
                                        autoComplete="off"
                                        type="number"
                                        min={1}   // ✅ HTML valida que no se pueda escribir menos de 1
                                        max={100} // ✅ HTML valida que no se pueda escribir más de 100
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal text-gray-900 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        id="exampleFormControlInput1"
                                        placeholder="1 - 100"
                                      />
                                    </div>
                                  </div>
                                </td>
                                
                                
                                <td className="text-xs text-gray-900 font-medium px-8  whitespace-pre-wrap">{formatearNumeroConPuntos(parseInt(item.ValorBaseTarifa) === 0? item.ValorUnitario : item.ValorBaseTarifa)}</td>
                                <td className="text-xs text-gray-900 font-medium px-8  whitespace-pre-wrap">{item.DescripcionTarifario}</td>
                              </tr>
                              
                            </tbody>
                          ))
                          
                          
                        }
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center bg-[#05a29d] pb-1">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mt-1 text-white font-medium px-1 text-xl "
              >
                Procedimientos quirúrgicos con formas de liquidación
              </label>
            </div>

            <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto ">
                  <div className="py-1 inline-block min-w-full ">
                    <div className="overflow-hidden">
                      <table className="min-w-full text-center bg-gray-200">
                        <thead className="">
                          <tr>
                          <th
                              scope="col"
                              className="text-sm font-medium text-gray-900"
                            >
                              
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Proced Qx
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Descripción
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Tipo
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900"
                            >
                              Agrupador
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Via
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Esp.Ciru
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Opción
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Orden M
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              C. Costo
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Vrl. Uvr
                            </th>
                          </tr>
                        </thead>

                        {
                          
                          dataProcedimientos.map((item)=>(
                            <tbody>
                              <tr className="divide-y divide-slate-700">
                                <td></td>
                                {/* <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap"></td>
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                  1
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                  1
                                </td>*/}
                                {/* <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                  {agrupadorMULTBILAINDV}
                                </td>  */}
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                  {/* {codigoProcedimiento} */}
                                  {item.CrgCod}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                  {/* {nombreProcedimiento} */}
                                  {item.PrNomb}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                  <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                      <select
                                        // onChange={handleOnChangeFacturableHojaGasto}
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        value={item.tipoHojaFact}
                                        
                                        onChange={(e) => handleSelectChangeTipo(item.CrgCod, e.target.value)}
                                      >
                                        <option value="seleccionar">-------------</option>
                                        <option value="F">Facturable</option>
                                        <option value="H">Hoja de Gasto</option>
                                      </select>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                <select
                                        // onChange={handleOnChangeFacturableHojaGasto}
                                        className="form-select block w-auto px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        //value={item.tipoHojaFact}
                                        value={item.agrupadorProcedimiento}
                                        onChange={(e) => handleSelectAgrupadorQX(item.CrgCod, e.target.value)}
                                      >
                                        
                                        <option value="BILA">Bilateral</option>
                                        <option value="INDV">Individual</option>
                                        <option value="MULT">Multiple</option>
                                      </select>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                  <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                      <select
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        value={item.via}
                                        onChange={(e)=>handleSelectChangeVia(item.CrgCod, e.target.value)}
                                      >
                                        <option value="seleccionar">-------------</option>
                                        <option value="1">Unica via</option>
                                        <option value="2">Diferente via</option>
                                        <option value="3">Bilateral</option>
                                      </select>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                  <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                      <select
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        value={item.especilidadCirujano}
                                        onChange={(e)=>handleSelectChangeEspecialidadCirujano(item.CrgCod, e.target.value)}
                                      >
                                        {/* <option value="seleccionar">-------------</option> */}
                                        <option value="1">Igual Especialidad</option>
                                        <option value="2">Diferente Especialidad</option>
                                      </select>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-8  whitespace-pre-wrap">
                                  <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                      <select
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        value={item.opcion}
                                        onChange={(e)=>handleSelectChangeOpcion(item.CrgCod, e.target.value)}
                                      >
                                        

                                        
                                        {
                                          dataOpcionCirugia.map((item)=>(
                                            <option value={item.PrcMulOpc} key={item.PrcMulOpc}>{item.PrcMulDsc}</option>
                                          ))
                                        }
                                      </select>
                                    </div>
                                  </div>
                                </td>

                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                  <div className="pt-2 ">
                                    <div className="mb-3 w-full">
                                      <input
                                        
                                        defaultValue={item.orden}
                                        onChange={(event) => handleChangeOrden(event, item.CrgCod)}
                                        autoComplete="off"
                                        type="number"
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                      />
                                    </div>
                                  </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-8  whitespace-pre-wrap">{dataUser.CNCCOD? dataUser.CNCCOD:null }</td>
                                <td className="text-xs text-gray-900 font-medium px-8  whitespace-pre-wrap">{item.PTCntUvr?item.PTCntUvr:null}</td>
                              </tr>
                              
                            </tbody>
                          ))
                          
                          
                          
                        }
                        
                            
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center bg-[#05a29d] pb-1">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mt-1 text-white font-medium px-1 text-xl "
              >
                Valor Honorarios
              </label>
            </div>
            
            <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto ">
                  <div className="py-1 inline-block min-w-full ">
                    <div className="overflow-hidden">
                      <table className="min-w-full text-center bg-gray-200">
                        <thead className="">
                          <tr>
                            <th></th>
                            {/* <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Pro
                            </th> */}
                            {/* <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cons
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              A.Qx
                            </th> */}
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cd.Prc
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Procedimiento
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cant
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Honorario
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-7 py-2"
                            >
                              Cod.Med
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Nombre Médico
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cod. Esp
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Especialidad
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              No Fac?
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Vr. Hono
                            </th>
                            {/* <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Tmpo
                            </th> */}
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Participo?
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Realizó?
                            </th>
                            {/* <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Docto
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Incluido Flq
                            </th> */}
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Forma Liq
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Vrl. Uvr
                            </th>
                          </tr>
                        </thead>
                        {
                          dataPreciosTabla.map((item, index)=>(
                            <tbody key={index}>
                              
                                <tr className="divide-y divide-slate-700" >
                                    <td></td>
                                    {/* <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                        <input
                                        type="checkbox"
                                        //   checked={selectedRows.includes(item.CodigoHonorario)}
                                        //   onChange={() => handleRowSelect(item.CodigoHonorario)}
                                        />
                                    </td> */}
                                    {/* <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
                                        
                                        
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
                                        
                                        
                                    </td> */}
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                        {item.CodigoProcedimiento}
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                        {item.NombreProcedimiento}
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
                                        {/* {item.cantidadProcedimiento} */}
                                        1
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                        {item.DescripcionHonorario}
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
                                      {
                                        item.RequiereCodigoProfesional === 'S'?
                                        <input
                                          value={item.CodigoMedico}
                                          //value={seleccionarMedico.MedCod}
                                          //disabled={true}
                                          autoComplete='off'
                                          onFocus={()=>handleonClickMedico(item)}
                                          type="text"
                                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                          id="exampleFormControlInput1"
                                          placeholder=""
                                          readOnly
                                      />
                                      :
                                      null
                                      }
                                      
                                      
                                        
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                        {item.NombreMedico}
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                        {item.CodigoEspecialidad}
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                        {item.NombreEspecialidad}
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
                                    <input
                                        type="checkbox"
                                        //disabled={item.tipoHojaFact === 'H'? true:false}
                                         checked={item.tipoHojaFact === 'H'} 
                                         onChange={() => handleCheckboxChangeIsFacturable(item.CodigoProcedimiento,item.DescripcionHonorario)}
                                        
                                        />
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-right	">
                                        {formatearNumeroConPuntos(item.ValorHonorario)}
                                    </td>
                                    {/* <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
                                        0
                                    </td> */}
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                    {
                                        item.RequiereCodigoProfesional === 'S'?
                                        <input
                                        type="checkbox"
                                          checked={item.CirujanoSoN === 'S'}
                                          onChange={(e) => onCheckboxChangeParticipo(index, e.target.checked,item)}
                                        />
                                        :
                                        null
                                        }
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                        <input
                                        type="checkbox"
                                        checked={true}
                                        disabled={true}
                                        //   checked={selectedRows.includes(item.CodigoHonorario)}
                                        //   onChange={() => handleRowSelect(item.CodigoHonorario)}
                                        />
                                    </td>
                                    {/* <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
                                        Docto
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
                                        Incluido flq
                                    </td> */}
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
                                        {item.CodigoFormaLiquidacion}
                                    </td>
                                    <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
                                        {item.CantidadUVR}
                                    </td>
                                    
                                </tr>
                              {modalOnMedico? <ModalMedicoLiquidacionQx setmodalOnMedico={setmodalOnMedico} passDataMedico={passDataMedico}/>:null}
                          </tbody>
                          ))
                        }
                       
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            
            
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                onClick={handleCancelClick}
                className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              {
                validarButtonDescargaPDF?
                <button
                    type="button"
                    onClick={handleClickGuardarLiquidacion}
                    className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                  >
                    Liquidar
                </button>
                  :
                //  <PDFDownloadLink document={<ModalAntesDescargarPDFLiquidacionQx dataPDF={dataPDF} dataUser={dataUser} dataHonorario={dataHonorario} valorTotalLiquidacionQx={valorTotalLiquidacionQx}/>} fileName="hjKleDSAiUWOXzYRdqXTIP.pdf">
                <PDFDownloadLink document={<ModalPDFPaquetesYFormasLiquidar dataPrecios={dataPrecios} dataProcedimientos={dataProcedimientos} dataPDF={dataPDF}  dataUser={item} dataPreciosPDF={dataPreciosPDF} totalPrecioProcedimiento ={totalPrecioProcedimiento} dataAnestesiologo={dataAnestesiologo} informacionEmpresa={informacionEmpresa} dataProcedimientosPaquete={dataProcedimientosPaquete} valorTotalProcedimientos={valorTotalProcedimientos}/>} fileName="pdffff.pdf">
                    <button
                    type="button"
                    onClick={handleClickGuardarLiquidacion}
                    className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                  >
                    Liquidar
                  </button>
                </PDFDownloadLink> 
              }
              
            </div>
              </div>
              :
              <LoadingModal/>
            }
            </div>
          
          
          
        </div>
        {
            loading? null:
            // <div className="text-center py-48"><Loading/></div>
            <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
          }
      </div>
      {/* {modalOnValidarHojaGasto? <ModalValidarSIesFacturableOHojaGastoLiquidacionesQx setmodalOnValidarHojaGasto={setmodalOnValidarHojaGasto}/>:null} */}
      {modalOnValidarSelect? <ModalValidacionSelectLiquidacionQx setmodalOnValidarSelect={setmodalOnValidarSelect} mensaje={mensajeSelect}/>:null}
      {modalOnConfirmarLiquidacion? <ModalConfirmarLiquidacionPaqueteYFormasLiquidar setmodalOnConfirmarLiquidacion={setmodalOnConfirmarLiquidacion} dataPrecios={dataPrecios} dataProcedimientos={dataProcedimientos} dataPDF={dataPDF}  dataUser={item} dataPreciosPDF={dataPreciosPDF} handleCancelClickLiquidacion={handleCancelClick} setactualizarDataLiquidacion={setactualizarDataLiquidacion} dataAnestesiologo={dataAnestesiologo} agrupadorMULTBILAINDV={agrupadorMULTBILAINDV} totalPrecioProcedimiento={totalPrecioProcedimiento} complicacionesDx={complicacionesDx} arrayProcedimientosProcedimiento={dataProcedimientosPaquete} valorTotalProcedimientos={valorTotalProcedimientos}/>:null}
      {modalOnValidarPTCodi? <ModalValidarPTCODILiquidacion setmodalOnValidarPTCodi={setmodalOnValidarPTCodi} handleCancelClickCerrarModalLiqudacion={handleCancelClick}/>:null}
      {modalOnValidarParticipo? <ModalValidarParticipo setmodalOnValidarParticipo={setmodalOnValidarParticipo}/>:null}
      {modalOnTarifario? <ModalValidarTarifarioLiquidacionQX setmodalOnTarifario={setmodalOnTarifario} handleCancelClickCerrarModalLiqudacion={handleCancelClick}/>:null}
    </div>
  )
}

//export default ModalLiquidarLosProcedimientosQx

export default ModalLiquidarPaquetesYFormasLiquidacion